import * as THREE from 'three';
import Complex from "SATPROF_UTILS/Complex";
/*
currentTimeSec():number
 
equalToNplaces
mod2Pi
minmax
sign(x); // Returns +1 or -1
signChar(x); // Returns "+" or "-"
distanceBetween(a:any, b:any)  Returns distance between any two objects that have x and y properties
distanceBetween2(ax:number, ay:number, bx:number, by:number)  Returns distance between a and b given their x and y values

zeroMCreg
    
clearMovieClip// Removes all child movieclips from the parent.

diffAng(a1, a2)  // Difference between two angles (a1-a2), normalized to +/- 180
polDiffAng(a1, a2) // Difference between two pol plane angles. Returns -90 to +90.
polPM90(ang)  // Polarization angle normalized to +/- 90 deg.
mod360(ang)    // Shifts angle in degrees to the range 0-360, even if negative.
pm180(ang)     // Shifts angle in degrees to the range -180- +180, even if negative. 
rss(a, b);  // sqrt of (a^2 + b^2)
ratioAbs(a, b); // Abs value of the ratio, always >= 0.  e.g. ratioAbs(1, 1.2) = 0.2

Formatting:
formatDecimals(a:number, n:number)  e.g. UtilSP.formatDecimals(x, 2)
formatLatLong2(val:number, posdir:string, P:number)   //Format a lat/long, P decimal places.  posdir = "N", "S", "E", "W" indicates positive sense
roundToFraction( number, denominator ); e.g. 4.26, 12 returns 4.250000
dir2text
polPresetCaseNo
formatFraction

Binary:
bit(d, n)  Returns bit n from number d.
nibble(d, n)  Returns nibble (4-bit word) n from number d.
XOR(a:boolean, b:boolean)
byte(d, n)  Returns byte n from number d.
XOR(a:boolean, b:boolean)
ip4octets2value(octetA:number,octetB:number,octetC:number,octetD:number):number
ip4netmaskbits2maskval(netmaskbits:number):number
ip4Details(srcip:number, destip:number, netmaskbits:number)  Returns object with various results
ip4isLocal(srcip:number, destip:number, netmaskbits:number):boolean
ip4format(ip:number)  Returns object with various results

c2rgba(col:string, alpha?:number):string{  // Generates hex rgba (color+alpha) from a color string and alpha number
        col can be either a valid css color string, or a hex rgb in format #nnnnnn
        alpha is 0-1
hexToRgbA(hex:string)
wavelength2color(wavelength:number)  Takes optical wavelength in nm (380-780 ) and generates color string of that temperature

Three.js utilities:
vector2toString(v:THREE.Vector2)
vector3toString(v:THREE.Vector3, n?:number)     n is number of decimal places
euler2string
localToWorld( point:Vector3, obj)  Point is in the frame of obj.  Returns transformed point in world space.
worldToLocal( point:Vector3, obj)  Point is in the frame of world.  Returns transformed point in obj space.
clearThreeJSGroup(grp:THREE.Group) // Clears all children from a THREE.Group object

Orbital mechanics:
circularOrbitRadius2Period(r_km)   Returns period in sec
keplerOrbitTLE
TLEtime2sec

Conversion functions:
degrees
radians
W2dBm( x )			//Watts to dBm
W2dBW( x )          //Watts to dBW 
dBW2W( x )          dBW to Watts 
dBm2W( x )          dBm to Watts
log10( x )          Log base 10
log10a( x )         // Base 10 log with large neg number for zero
tenlog( x )
Vrms2dBm( Vrms, Z )
Vratio2dB( Vratio )
dB2Vratio( dB )
sumdBPowers( a:Array )
sum2CWsignals( p1dBx:number, ph1deg:number, p2dBx:number, ph2deg:number):
i2f(i, fstart, fstop, nfreqs)




Waveforms:
rampWave( t, ramptime, vBottom, vTop, repeating ); //t, ramptime, vBottom, vTop, repeating
rampDwell( t, ramptime, dwelltime, vBottom, vTop, repeating ); //t, ramptime, dwelltime, vBottom, vTop, repeating
rampWaveN( t:number, ramptimeList:Array, pointList:Array, repeating:Boolean ) e,g, v = Util3.rampWaveN( t, [0, 2, 3], [10,20,15], true);
sineWave( t, period, vAmpl, vAvg, repeating ); //t, period, vAmpl, vAvg, repeating
triangleWave(  t, period, vAmpl, vAvg, repeating ); //t, period, vAmpl (0-p), vAvg, repeating 
triangleWave2(  t, period, vBottom, vTop, repeating ); // t, period, vBottom, vTop, repeating
triangleWave2Dwell( t, period, dwelltime, vBottom, vTop, repeating ): // t, period, dwelltime, vBottom, vTop, repeating
squareWave(  t, period, vAmpl, vAvg, repeating ); //t, period, vAmpl (0-p), vAvg, repeating 
calcWavePoint

Pointing:
pointing_az(ES_long, ES_lat, sat_long); // Returns az in degrees from north (0-360).
pointing_el(ES_long, ES_lat, sat_long)
pointing_pol(ES_long, ES_lat, sat_long) // Clockwise looking towards satellite.  0 when sat_long = ES_long
pointing_feedRotation(ES_long, ES_lat, sat_long, definedSense, actualSense ) // Returns feed rotation in degrees, where positive is CW when looking into the dish.
ellipseR(thetaDeg, majorDia, minorDia)  // Radius from center to ellipse.
pointing_scannedBeamAzEl(mainBeamAz, mainBeamEl, scanBeamDistanceDeg, tiltDeg, scanBeamRadiusDeg, scanBeamAngleDeg)
scanTilt2AzEl(A0deg, E0deg, Sdeg, Tdeg)
beamwidth2loss( hb, hb3 ) Converts antenna half beamwidth angle to off-axis loss.  Requires 3-dB half beamwidth.  Uses parabolic assumption.
pointing_lossToTarget(az, el, targetAz, targetEl, hb3); // Pointing loss to a target satellite az-el from current antena direction az/el 
pointing_diff_angle( az1, el1, az2, el2); // Subtended angled between two vectors in defined by their az-el angles
pointing_slantrange(ES_long, ES_lat, sat_long); // in km
freeSpaceLoss(freq_MHz:number, distance_km:number):number
pathLoss(freq_MHz:number, distance_km:number):number ; // same as freeSpaceLoss
EIRP2PFD(EIRP_dBW:number, distance_km:number):number;  // Returns power flux density from EIRP and distance
pointing_loss(freq_GHz, dia_m, eff, angle_deg); // Loss (>0) of main beam at an angle off axis
pointing_errorBeamBalance( hbw3, L, E); // hbw = 3dB half beamwidth; L = pointing loss to ref level; E = meter error 
pointing_angle(freq_GHz, dia_m, eff, loss); // Off axis angle for given loss (>0) in main beam.  Gives the beamwidth at chosen loss
pointingO3b_az
pointingO3b_el
pointingSatLong(elDeg, ES_long, ES_lat, orbitHeightAboveSurface_km):createjs.Point
		// For equatorial orbit, returns the satellite longitude for a given elevation angle and site latitude.
StabAntSettings2Pointing
StabAntPointing2Settings
rangeToLEO(altitude_km, elevation)
sunAzEl(param, Lon_deg, Lat_deg, yearNo, monthNo, dayNo, UTC_hrs)   Returns az or el of the sun
antEllipticalEffectiveDia( majorDia_m, minorDia_m )  // Dia of a circle that has the same area as a given ellipse
antEllipticalGaindB( majorDia_m, minorDia_m, freq_MHz, eff )
ellipseArea(majorDia, minorDia)

Random functions:
randGaussian(); // Returns zero-mean Gaussian random number, sigma = 1.  For mean = m sigma = s, multiply by returned value s and add m.
randRange(min, max); // Returns random number in the range min to max
randRangeInt(min, max); // Returns random integer in the range min to max
randRangeIntExcept // Same as randRangeInt but will not return the except value (ignores it)
randRangeWithZeroGap(min, max); // Returns random number in the range -max to -min and +min to +max
randBool(); // Returns random true/false
Note: for a seeded random generator, use class RandomWithSeed

Array utilities:
clearArray  // Removes all elements from an array.
fillArrayOfNumbers  // Fills array A with the value f
fillArrayOfComplex  // Fills array A with the value f
newFilledArrayOfNumbers  // Makes a new array of length len, filled with the value f
shuffledArray(len); // Returns an array containing integers 0...len in random order (nonrepeating)
resampleArrayC(origArray:Array<Complex>, newLength:int) // Returns resampled (smaller) array. orig can be array of Number or Complex. newLength must be less than orig length.
insertionSort(values:Array<number>, ascending:boolean)  // Returns array of indices into values array

Filter responses:
filterGaussian(w:Number) Gaussian weighting filter net gain - power transfer function. Returns array.
filterGaussian2(w:Number, b:int)
filterGaussian3(len:int, b:Number, fc:Number, gain:Number)
modFilter(frq, symbrate, alph, filtType) Raised cosine or raised root cosine filter for PSK modulation


Antennas and link budgets:
HB3toGain(hb3)  Convert 3dB half bandwidth in degrees to on-axis gain in dB
gain2HB3(gain_dB)  Convert on-axis gain in dB to 3dB half bandwidth in degrees
loss2beamwidth( L, hb3 )  Converts antenna off-axis loss (positive) to half-beamwidth at that loss.  Requires 3-dB half beamwidth. Uses parabolic assumption.
antennaPattern(angle_deg, dia_m, freq_MHz, eff, sidelobeLeveldB, type)  Synthesizes a parabolic antenna gain pattern
antGaindB( dia_m, freq_MHz, eff ); // On-axis gain
antBeamwidth( dia_m, freq_MHz, eff ); // 3 dB half beamwidth
antennaPatternFromHBW( angle_deg, HalfBW3dB, gOnAxisdB, sidelobeLeveldB, type )
antennaNoiseTempInRain(rainFadedB:Number, Tant:Number, Tsky:Number, TgroundPhys:Number, TatmPhys:Number, TrainPhys:Number)

Specialized functions:
iDirectCNtoPWMVolts(CNR, sigLevel, sigLevelBaseline); // Converts CNR and signal level in dB to the PWM voltage dislplayed and output by the iDirect iNFINITY IDU		
CNR2iDirectVoltage( CNR, CNRlock, tunedToCorrectCarrier, totalWidebandPowerdBm, coldSkyWidebandPowerdBm )		
SpaceTrackPointingLossToAGC( signaldBm, inputAttendB, thresholdPct ); // Converts signal level to AGC value in Schlumberger SpaceTrack tracking receiver
DIRECTVdB2IRD(dB)   // Curve fit measured dB down from peak to IRD value.
DIRECTV_CN2IRD(dB)   // Curve fit of measured IRD value vs. C/N indicated by SuperBuddy
EsNo2HNSQF  // Curve fit to Hughes HN display when locked to a DVB-S2 signal.
isEven
quadraticRoot1      Upper root
quadraticRoot2      Lower root
snapTo(a, s)  // Returns a snapped to the nearest multiple of s
snapPointTo(p:createjs.Point, s:Number) // Returns p whose x and y are both snapped to the nearest multiple of s
waveguideCutoff_GHz(a_mm, b_mm, m, n, Er)     Waveguide cutoff freq in GHz for TEmn
*/




export default class UtilSP {
    static earthRadiuskm:number = 6378.16;// Radius of the earth (km)
    static geoHeightkm:number = 35786.24;// Geostationary height (km)
    static geoRadiuskm:number = 42164.4; // Geostationary radius (fron center of earth) (km)
    static O3bHeightkm:number = 8000;// O3b orbit height (km)
    static mu:number = 3.986E14; // GM (gravitational constant for the earth times the mass of the earth) meters/seconds

    static boltzmannConstant_WHz:number = 1.3806504e-23;
    static boltzmannConstant_dBW1Hz:number = -228.599163;
    static siderealDay_sec:number = 86164.0905;
    static solarDay_sec:number = 60*60*24; //86400 86,400.002
    static calendarYear_sec:number = 365 * UtilSP.solarDay_sec;

    static vector2toString(v:THREE.Vector2):string{
        return ("(x:"+v.x+", y:"+v.y+")");
    }
    static vector3toString(v:THREE.Vector3, n?:number):string{
        if (n){
            return ("(x:"+UtilSP.formatDecimals(v.x,n)+
            ", y:"+ UtilSP.formatDecimals(v.y,n)+
            ", z:"+ UtilSP.formatDecimals(v.z,2)+")");
        } else {
            return ("(x:"+v.x+
                ", y:"+ v.y+
                ", z:"+ v.z+")");
        }
    }  
    static localToWorld( point:THREE.Vector3, obj:any):THREE.Vector3 {
         //Point is in the frame of obj.  Returns transformed point in world space.
        let worldPoint:THREE.Vector3 = point.clone();
        obj.localToWorld(worldPoint);
        return worldPoint;
    }
    static worldToLocal( point:THREE.Vector3, obj:any):THREE.Vector3 {
        // Point is in the frame of world.  Returns transformed point in obj space.
        let localPoint:THREE.Vector3 = point.clone();
        obj.worldToLocal(localPoint);
        return localPoint;       
    }
    static euler2string(e:THREE.Euler, n?:number):string{
        if (n){
            return ("(x:"+UtilSP.formatDecimals(UtilSP.degrees(e.x),n)+
            ", y:"+ UtilSP.formatDecimals( UtilSP.degrees(e.y),n)+
            ", z:"+ UtilSP.formatDecimals(UtilSP.degrees(e.z),2)+")");
        } else {
            return ("(x:"+UtilSP.degrees(e.x)+
                ", y:"+ UtilSP.degrees(e.y)+
                ", z:"+ UtilSP.degrees(e.z)+")");
        }
    }


    static degrees(valRad:number):number{
        return valRad * 180 / Math.PI;
    }
    static radians(valDeg:number):number{
        return valDeg *  Math.PI / 180;
    }    
    static equalToNplaces(a:number, b:number, N:number):boolean{
		// Returns true if a and b a equal to N decimal places.
		let m:number = Math.pow(10,N);
		return ( Math.round(a*m) == Math.round(b*m) );
    }
    static mod2Pi(ang:number):number {
        // Shifts angle in degrees to the range 0-2Pi, even if negative.
        let b:number;
        b = ang%(2*Math.PI);// This gets it in the range -2Pi to +2Pi.
        if (b<0) {
            b += 2*Math.PI;
        }
        return b;
    }
    static mod360(ang:number) {
        // Shifts angle in degrees to the range 0-360, even if negative.
        let b:number;
        b = ang%360;// This gets it in the range -360 to +360.
        if (b<0) {
            b += 360;
        }
        return b;
    } 
    static pm180(ang:number) {
        // Shifts angle in degrees to the range -180- +180, even if negative.
        let a:number = UtilSP.mod360(ang);
        if (a>180) {
            return a - 360;
        } else {
            return a;
        }
    } 
    static diffAng(a1:number, a2:number):number{
        let aa1:number = UtilSP.mod360(a1);
        let aa2:number = UtilSP.mod360(a2);
        if (aa1 < aa2){
            aa1 += 360;
        }
        let d:number= UtilSP.pm180(aa1 - aa2);
        return d;
    }
        public static angleIsBetween(ang:number, min:number, max:number):boolean{
        // True if angle is between min and max
        let ret:boolean;
        let a:number = UtilSP.mod360(ang);
        let b:number = UtilSP.mod360(min);
        let c:number = UtilSP.mod360(max);
        
        if (c<b){
            c += 360;
        }
        if ( a < b ){
            a += 360;
        }
        if ( a >= b && a<= c){
            ret = true;
        } else {
            ret = false;
        }
        return ret;
        }
    public static angIsGreater( a:number, b:number ):boolean{
        // Returns a > b, based on which side of the circle they are both on.
        let greater:boolean;
        let a1:number = a%360;
        let b1:number = b%360;
        let c = UtilSP.pm180(a1 - b1);
        greater = (c>0);
        return greater;
    }    
    public static polDiffAng(a1:number, a2:number){
        // Fixed 8/29/2012 RB
        return UtilSP.polPM90(a1 - a2);
    } 
    public static polPM90(a:number){
        let temp1:number = a%180;
        let retval:number = temp1;
        if (temp1 < -90 ){ retval = temp1 + 180; };
        if (temp1 > 90 ){ retval = temp1 - 180; };
        return retval;
    }       
    public static polPresetCaseNumber(polUplinkSense:string, ES_lat:number, targetAz:number){
        // Selects which diagram is the correct case in SP-REF-001, Rev 5
        let caseNo:number;
        if (polUplinkSense=="V"){
            if (  (ES_lat>= 0 && targetAz < 180) || (ES_lat< 0 && targetAz >= 270)  ){
                caseNo = 1;
            } else {
                caseNo = 2;
            }
        } else {
            if (  (ES_lat>= 0 && targetAz < 180) || (ES_lat< 0 && targetAz >= 270)  ){
                caseNo = 3;
            } else {
                caseNo = 4;
            }
        }
        return caseNo;
    }    
    static formatDecimals(a:number, n:number, len?:number):string{
        // Format a number to n decimal places and return string
        // n = number of decimal places, 0 or more.
        // len = total length. Prepads with spaces if necessary.
        let s:string = String( (Math.round(a*Math.pow(10, n) ))/ Math.pow(10,n));
        if (len){
            return s.padStart(len, " ");
        } else {
            return s;
        }
    } 
    static roundToFraction( a:number, n:number ):number{
        return Math.round(a*n)/n;
    }
    static formatLatLong2(val:number, posdir:string, P:number){
        //Format a lat/long, P decimal places.  posdir = "N", "S", "E", "W" indicates positive sense
        let pos:boolean;
        if (val > 0){
            pos = true;
        } else {
            pos = false;
        }
        //let fmt = "%"+(P+4)+"."+P+"f"; // 359.123
        //let a = sprintf3(fmt, Math.abs(val));
        let a:string = UtilSP.formatDecimals(Math.abs(val), P);
        //let a = formatFloat(Math.abs(val), 5, 1);
        let retstring:string = "";
        switch (posdir){
            case "N":
                if (pos) { 
                    retstring = (a + "°N");
                }else{
                    retstring = (a + "°S");
                }
                break;
            case "S":
                if (pos) { 
                    retstring = (a + "°S");
                }else{
                    retstring = (a + "°N");
                }
                break;
            case "E":
                if (pos) { 
                    retstring = (a + "°E");
                }else{
                    retstring = (a + "°W");
                }
                break;
            case "W":
                if (pos) { 
                    retstring = (a + "°W");
                }else{
                    retstring = (a + "°E");
                }
                break;
            default:
                retstring = "ERROR in formatLatLong2: unrecognized posdir "+posdir;
        }
        return retstring;

    }
    static formatFraction( a:number, n:number ):string{
        // number, denominator)   e.g. 4.25 returns "4 3/12"
        //debugger;
        let aa:number = Math.abs(a);
        let i:number = Math.floor(aa); // Whole number
        let r:number = aa - i; // Remainder
        let num:number = Math.round( r * n ); // Number of fractions
        if ( num == n ){
            num = 0;
            i+= 1;
        }
        
        let s:string = "";
        if ( i == 0 && r == 0){
            s = "0"
            return s;
        }
        // Non-zero:
        if (a< -(1/n) ){
            s += "-";
        }
        
        if ( num == 0 ){
            // No numerator
            s += i;
            return s;
        } 
        if ( i != 0 ){
            s += i +" & ";
        }
        s +=  num + "/" + n;
        return s;

    }
    static formatComplex(re:number, im:number, decPlaces:number):string{
        let reStr:string = re.toFixed(decPlaces);
        let imStr:string
        if (im >= 0){
            imStr = " + j"+im.toFixed(decPlaces)
        } else {
            imStr = " - j"+Math.abs(im).toFixed(decPlaces)
        }
        return (reStr + imStr);
    }
    static dir2text(dir:number):string{
        if (dir >= 0){
            return "CW";
        } else {
            return "CCW"
        }
    }
	static polPresetCaseNo(rxPol:string, azRaw:number, northernHemisphere:boolean):number{
		//  Returns case no (1-4) per the diagram in SP-REF-001
        let az:number = UtilSP.mod360(azRaw);

		let caseNo:number;
		if (rxPol == "H"){
			if ( northernHemisphere && (az <= 180) || !northernHemisphere && ( az >= 270 && az <= 360) ){
				caseNo = 1;
			} else if ( northernHemisphere && (az > 180) || !northernHemisphere && ( az>= 0 ) ){
				caseNo = 2;
			}
		} else {
			if ( northernHemisphere && (az <= 180) || !northernHemisphere && (az >= 270 && az <= 360) ){
				caseNo = 3;
			} else {
				caseNo = 4;
			}
		}
        //console.log("In UtilSP.polPresetCaseNo, rxPol = "+rxPol+", az = "+az+", northernHemisphere = "+northernHemisphere+": caseNo = "+caseNo);
		return caseNo;
	}    
    static minmax(val:number, min:number, max:number):number{
		return Math.max(min, Math.min(val, max));
    }
	public static sign(xx:number):number{
		if (xx>=0){
			return +1;
		}else{
			return -1;
		}
	}
	public static signChar(xx:number):string{
		if (xx>=0){
			return "+";
		}else{
			return "-";
		}
	}    
    static distanceBetween(a:any, b:any):number{
		// sqrt of (a^2 + b^2)
		// Should work if a and b are objects that have x and y properties
		return (Math.sqrt( (b.x - a.x)*(b.x - a.x) + (b.y - a.y)*(b.y - a.y) ) );
    }
    static distanceBetween2(ax:number, ay:number, bx:number, by:number) :number{
		//  Returns distance between a and b given their x and y values
		return (Math.sqrt( (bx - ax)*(bx - ax) + (by - ay)*(by - ay) ) );
    }    



    static zeroMCreg( mc:any){
        // CreateJS x,y properties are the registration point (transformation point in the Free Transform tool.).
        // regX, regY properties are the position of the registration point w.r.t. the movieclip's true x,y
        // This function changes the x,y properties to be the true x,y and zeroes out the registation point.
        mc.x -= mc.regX;
        mc.regX = 0;
        mc.y -= mc.regY;
        mc.regY = 0;
    }
    static currentTimeSec():number{
        let dateObj = new Date();
        return dateObj.getTime()/1000;
    }
    static TLE2GEOlong( paramsObj:any):number{
        let long0:number = 0; // Longitude facing X axis (first point of ares) at the epoch time
        let TA_at_epoch_deg:number = paramsObj.Raan_deg + paramsObj.AOP_deg + paramsObj.MAatEpoch_deg;
        //let t:number = Number(yrStr)*365.25*24*60*60 + Number(moStr)*(365.25/12)*24*60*60 + Number(dayStr)*24*60*60 + Number(hrStr)*60*60 + Number(minStr)*60 + Number(secStr);
        let earth_rotations_at_epoch =  paramsObj.Te_sec/ this.siderealDay_sec
        let offset = -354.2;

        let satLong:number = UtilSP.mod360(TA_at_epoch_deg - earth_rotations_at_epoch*360 + offset);
        return satLong;
    }
   static keplerOrbitTLE( tNow_sec:number, paramsObj:any):THREE.Vector3{

    let v4:THREE.Vector4 = UtilSP.keplerOrbitTLE_TA( tNow_sec, paramsObj); // Includes True Anomaly at the end
    let v3:THREE.Vector3 = new THREE.Vector3(v4.x, v4.y, v4.z);
    return v3;
   }
 
    static keplerOrbitTLE_TA( tNow_sec:number, paramsObj:any):THREE.Vector4{
        /* 
        tNow_sec        Time since A.D. 0 in seconds. (= the date + time of day)

        paramsObj properties must be:
        incl_deg        Orbit inclination. 0 = orbit is in equatorial plane
        e               Eccentricity. 0 = circular orbit.
        Raan_deg        Right ascension of the ascending node
        AOP_deg         Argument of Peripasis
        MAatEpoch_deg   Mean anomaly at the epoch time
        MM_rpd          Mean Motion in revolutions per solar day
        Te_sec          Epoch time in seconds

        Returns satellite position at time tC as Vector3 in km. in sidereal space. plus its True Anomaly in deg
        */
           /*
            Assume we are using the equatorial plane as the reference plane.
            See OrbitalMechanics1.fla
            
            Orbit equations are from:
            http://en.wikipedia.org/wiki/Orbit
            http://en.wikipedia.org/wiki/Orbital_period
            http://en.wikipedia.org/wiki/Standard_gravitational_parameter
        

            */

        let mu:number = 3.986E14; // GM (gravitational constant for the earth times the mass of the earth) meters/seconds

        let incl_deg:number = Number(paramsObj.incl_deg);
        let e:number = Number(paramsObj.e);
        let Raan_deg:number = Number(paramsObj.Raan_deg);
        let AOP_deg:number = Number(paramsObj.AOP_deg);
        let MAatEpoch_deg:number = Number(paramsObj.MAatEpoch_deg);
        let MM_rpd:number = Number(paramsObj.MM_rpd);
        let Te_sec:number = Number(paramsObj.Te_sec);
        let tSinceEpoch = tNow_sec - Te_sec;

        //console.log("---------------------------------------------");
        //console.log("IN UtilSP.keplerOrbitTLE, tSinceEpoch = "+tSinceEpoch+", objectName = "+paramsObj.objectName);
        //console.log("tNow_sec = "+tNow_sec+", Te_sec = "+Te_sec+", tSinceEpoch = "+tSinceEpoch);
        //console.log("incl_deg = "+incl_deg+", e = "+e+", Raan_deg = "+Raan_deg+", AOP_deg = "+AOP_deg+", MAatEpoch_deg = "+MAatEpoch_deg+", MM_rpd = "+MM_rpd+", Te_sec = "+Te_sec);
        let n:number = MM_rpd * 2 * Math.PI / UtilSP.solarDay_sec;  // Mean motion rad/sec = d(MA)/dt
        let T:number = UtilSP.solarDay_sec/MM_rpd; // Period in seconds
        //console.log("n = "+n+", mu = "+mu);
    
        //n = sqrt( mu / a^3 )
        // a^3 = mu / n^2
        // a = ( mu / n^2 ) ^ 1/3
        let a:number = Math.pow(  mu/(n*n), (1/3)); // Semi-major axis in m
        let MAatEpoch_rad:number = UtilSP.radians(MAatEpoch_deg);
        let MA_rad:number = MAatEpoch_rad + n * tSinceEpoch ; // Mean Anomaly
        MA_rad = UtilSP.mod2Pi(MA_rad);

       // Eccentric anomaly:
       let EA_rad:number = MA_rad + (2*e - (1/4)*e*e*e)*Math.sin(MA_rad)
       + (5/4)*e*e*Math.sin(2*MA_rad)
       + (13/12)*e*e*e*Math.sin(3*MA_rad); // Initial terms of series

        // True anomaly:
        let TA_rad:number = 2 * Math.atan( Math.sqrt( (1+e)*Math.tan(EA_rad/2)*Math.tan(EA_rad/2) ) / (1-e)  );
        if (MA_rad > Math.PI){
            TA_rad = -TA_rad;
        }
        TA_rad = UtilSP.mod2Pi(TA_rad);
        //console.log("MA deg = "+UtilSP.degrees(MA_rad));
        //console.log("TA deg = "+UtilSP.degrees(TA_rad));
        //console.log("EA deg = "+UtilSP.degrees(EA_rad));
        let r_m:number = a*( 1 - e*Math.cos(EA_rad) ); // Distance from center of earth to satellite
        //console.log("a = "+a+", TA_rad = "+TA_rad+", EA_rad = "+EA_rad+", MA_rad = "+MA_rad)
/*
             const earthRadiuskm = 6378.16;// Radius of the earth (km)

            this.satApogeeHeightkm = paramsObj.satApogeeHeightkm;
            this.satPerigeeHeightkm = paramsObj.satPerigeeHeightkm;
            this.satInclDeg = paramsObj.satInclDeg;
            this.satRaanDeg = paramsObj.satRaanDeg;
            this.satAOPDeg = paramsObj.satAOPDeg;
            this.satPhaseOffsetDeg = paramsObj.satPhaseOffsetDeg;
            this.tSinceEpochSec = paramsObj.tSinceEpochSec;

            //console.log("In Util3.keplerOrbit -----------------------------------------------")
            let isCircular = UtilSP.equalToNplaces(this.satApogeeHeightkm, this.satPerigeeHeightkm, 7); // Returns true if a and b a equal to N decimal places.
            // console.log("isCircular = "+isCircular+", satPhaseOffsetDeg = "+satPhaseOffsetDeg);
            //console.log("tSinceEpochSec = "+tSinceEpochSec);
            if (isCircular){
                    a = 1000*(this.satApogeeHeightkm + earthRadiuskm);
                    r = a;
                    n = Math.sqrt( mu / (a*a*a) ); // Mean angular motion = dMA/dt
                    TA = n * this.tSinceEpochSec + UtilSP.radians(this.satPhaseOffsetDeg);
                    e = 0;
            } else {
                // Semi-major axis of orbit
                let AD = 1000 * (this.satApogeeHeightkm + earthRadiuskm); // Apogee distance from center of earth
                let PD = 1000 * (this.satPerigeeHeightkm + earthRadiuskm); // Perigee distance from center of earth
                a = (AD+PD)/2; // Semi-major axis
                e = (AD-PD)/(AD+PD) ; // Eccentricity
                n = Math.sqrt( mu / (a*a*a) ); // Mean angular motion = dMA/dt
                // Mean anomaly:
                MA = n * this.tSinceEpochSec + UtilSP.radians(this.satPhaseOffsetDeg); // Mean anomaly in radians
                MA = UtilSP.mod2Pi(MA);
             }
        }
        // Eccentric anomaly:
        let EA = MA + (2*e - (1/4)*e*e*e)*Math.sin(MA)
        + (5/4)*e*e*Math.sin(2*MA)
        + (13/12)*e*e*e*Math.sin(3*MA); // Initial terms of series

        // True anomaly:
        TA = 2 * Math.atan( Math.sqrt( (1+e)*Math.tan(EA/2)*Math.tan(EA/2) ) / (1-e)  );
        if (MA > Math.PI){
        TA = -TA;
        }
        TA = UtilSP.mod2Pi(TA);

        r = a*( 1 - e*Math.cos(EA) ); // Distance from center of earth to satellite
        // Integration constant for Kepler's 2nd law
        let k = Math.sqrt(a * mu ); // Not sure if we need this
        let dThetadT = k / (r * r); // Angular velocity???
*/

 

        //traceToConsole("In Util3 point A");
        // Period:
        //let T = 2*Math.PI* Math.sqrt(  a*a*a / mu);	// http://en.wikipedia.org/wiki/Orbital_period
        /*       
        // Now convert to cartesian coordinates.
        // x axis is from the center of the earth towards zero celestial longitude (reference direction, i.e. first point of Aries).
        // y axis is from the center of the earth towards 90 deg east celestial longitude.
        // z axis is from the center of the earth towards the zenith.
        // We start with the orbit in the x-y plane.  Perigee is on the +x axis with y=0, x = 0.
        // Major axis of the orbit is along the x axis.  Apogee is on the -x axis.

        See OrbitalMechanics.fla
        Original (RH, above)       Three.js (RH)
        X                           Z
        Y                           X
        Z                           Y
        */
        // Original code was Util3.as  keplerOrbit()
         /*
         Standard coordinates vs [3JS coordinates]

                    +Z [+Y] |    / +Y [+X]
                            |   /
                            |  /
                            | /
                            |/
          ------------------/---------------- +X  [+Z]
                           /|
                          / |
                         /  |
                        /   |

        */
       // console.log("r_m = "+r_m+", TA_rad = "+TA_rad);
        // x0, y0 is the satellite's location on the original flat x-y plane. (z0,x0 in 3JS)
        let z0:number = r_m * Math.cos( TA_rad );
        let x0:number = r_m * Math.sin( TA_rad );
        let y0:number = 0;
        let v1:THREE.Vector3 = new THREE.Vector3(x0,y0,z0);
        //console.log("A: v1 = "+v1.x+", "+v1.y+", "+v1.z);
     
        let incl_rad:number = UtilSP.radians(incl_deg);
        let AOP_rad:number = UtilSP.radians(AOP_deg);
        let Raan_rad:number = UtilSP.radians(Raan_deg);
    
        //1. Rotate around Z by Argument Of Periapsis. (Stay in X-Y plane) (around Y in 3JS)
        let m1:THREE.Matrix4 = new THREE.Matrix4();
        m1.makeRotationAxis(new THREE.Vector3(0,1,0), AOP_rad);
        v1.applyMatrix4(m1);
        //console.log("B: v1 = "+v1.x+", "+v1.y+", "+v1.z);
        //   
        //2. Rotate around the Y' axis by inclination. Ascending node will still be in the X-Y plane.
        // In 3JS: Rotate around the X' axis by inclination. Ascending node will still be in the X-Z plane.
        let xPrimeAxis:THREE.Vector3 = new THREE.Vector3( Math.cos(AOP_rad), 0, -Math.sin(AOP_rad) );
        let m2:THREE.Matrix4 = new THREE.Matrix4();
        m2.makeRotationAxis(xPrimeAxis, incl_rad);
        v1.applyMatrix4(m2);
        //console.log("C: v1 = "+v1.x+", "+v1.y+", "+v1.z);
             
        //3. Rotate around Z by RAAN (around Y in 3JS)
        let m3:THREE.Matrix4 = new THREE.Matrix4();
        m3.makeRotationAxis(new THREE.Vector3(0,1,0), Raan_rad);
        v1.applyMatrix4(m3);     
        v1 = v1.multiplyScalar(1/1000) ; // Convert from m to km

        //console.log("D: tSinceEpoch = "+ tSinceEpoch +", v1 = "+v1.x+", "+v1.y+", "+v1.z);
        //console.log("Calc long = "+UtilSP.degrees(Math.atan2(-v1.z, v1.x)));
 
        //console.log("a = "+a+", TA rad = "+TA+", v1 = "+v1.x+", "+v1.y+", "+v1.z);
        let v4:THREE.Vector4 = new THREE.Vector4(v1.x, v1.y, v1.z, UtilSP.degrees(TA_rad));
        return v4; 
    }
    public static TLEtime2sec(tStr:string):number{
        // Example: "2020-06-27T23:30:01.049184"
        let yrStr:string = tStr.substr(0,4);
        let moStr:string = tStr.substr(5,2);
        let dayStr:string = tStr.substr(8,2);
        let hrStr:string = tStr.substr(11,2);
        let minStr:string = tStr.substr(14,2);
        let secStr:string = tStr.substr(17);
       // console.log("tStr = "+tStr+": "+yrStr+","+moStr+","+dayStr+","+hrStr+","+minStr+","+secStr);
        let t:number = Number(yrStr)*365.25*24*60*60 + Number(moStr)*(365.25/12)*24*60*60 + Number(dayStr)*24*60*60 + Number(hrStr)*60*60 + Number(minStr)*60 + Number(secStr);
        //console.log("==> t = "+t);
        return t;
    }
    public static TLEepochYearDay2sec(epochYear:string, epochDay:string):number{
        // Converts the epoch year and day form the classic TLE values to time in seconds.
        let yr:number;
        let yr2:number = Number(epochYear);
        if (yr2 >= 57 ){
            yr = 1900 + yr2;
        } else {
            yr = 2000 + yr2;
        }
        let day:number = Number(epochDay); // Decimal
        let t:number = yr*365.25*24*60*60 + day*24*60*60;
        return t;
    }
    public static circularOrbitRadius2Period(r_km:number):number{
        // See OrbitalMechanics1.fla
        let mu:number = 3.986E14; // GM (gravitational constant for the earth times the mass of the earth) meters/seconds
        let T:number; // period in seconds
        let a:number = r_km * 1000; // meters
        T = 2*Math.PI / Math.sqrt( mu / (a*a*a));
        return T;
    }
    public static apogeeHeightPerigeeHeight2Period(apogeeHeight_km:number, perigeeHeight_km:number):number{
        // See OrbitalMechanics1.fla
        let AD = (apogeeHeight_km + UtilSP.earthRadiuskm)*1000; // m apogee distance from center of earth
        let PD = (perigeeHeight_km + UtilSP.earthRadiuskm)*1000; // m perigee distance from center of earth
        let a:number = (AD + PD)/2; // Semi-major axis
        let n = Math.sqrt( UtilSP.mu / (a*a*a) );  // /mu = GM (gravitational constant for the earth times the mass of the earth) meters/seconds
        let T:number = 2 * Math.PI / n; // Period sec
        return T;
    }
    public static periodSec2CircularAltitudekm(T:number){
        // See OrbitalMechanics1.fla step 3
        let a:number = Math.pow(  (( UtilSP.mu * T )/ (2 * Math.PI)), 1/3 );
        let altkm:number = a*1000 - UtilSP.earthRadiuskm;
        return altkm;
    }
    public static MA2EA(MA:number, e:number){
        // Returns Elliptic Anomaly as a function of Mean Anomaly and eccentricity.
        // MA and EA are in radians.
        // MA = EA - e sin(EA)
        //Uses Newton-Rhapson method
        let y = 99e9;
        let x:number = MA; // Initial guess
        let iter:number = 0;
        let tol:number = 1e-9;
        let ydot:number = 1e-9;
        let xNew:number;
        let done:boolean = false;
        do {
            y = x - e * Math.sin(x) - MA; // Find x = EA for y=0
            if (Math.abs(y) > tol){
                ydot = 1 - e*Math.cos(x);
                xNew = x - y / ydot;
                x = xNew; 
                iter++;
            } else {
                done = true;
            }
        }
        while ( iter <= 100 && !done);
        //console.log("iter = "+iter+", y = "+y)
        if (iter > 100){
            console.log("WARNING: MA2EA failed to converge after 100 iterations. MA = "+MA+", e = "+e);
        }
        return x;
    } 
    public static clearMovieClip(mc:any):void{
		// Removes all child movieclips from the parent.
		//console.log ('in clearMovieClip: ');

		try {
			//console.log ('before : '+mc.numChildren);
			while(mc.numChildren)
			{
				mc.removeChildAt(0);
			}
			//console.log ('   after : '+mc.numChildren);
		} catch (error){
			
		}
    }
    public static clearThreeJSGroup(grp:THREE.Group){
        for (let j:number = grp.children.length-1; j>= 0; j--){
            //console.log("Removing j= "+j);
            grp.remove(grp.children[j]);
        }
    }
    public static rampWave( t:number, ramptime:number, vBottom:number, vTop:number, repeating:Boolean ):number {
        let tNorm;  // Normalize time to 0-1
        let v;
        if ( (t >= ramptime) && (!repeating) ){
            v = vTop;
            //console.log("In Util3.rampWave, t = "+t+", ramptime = "+ramptime+", t >= ramptime, v = "+v);
        } else {
            tNorm = (t%ramptime)/ramptime;
            
            if ( tNorm < 0 ){
                v = vBottom;
            } else if (tNorm < 1){
                v = vBottom + (vTop-vBottom)*tNorm;
            } else {
                v = vTop;
            }
            //console.log("In Util3.rampWave, tNorm = "+tNorm+", v = "+v);
        }
        return v;
        
    }
    public static rampDwell( t:number, ramptime:number, dwelltime:number, vBottom:number, vTop:number, repeating:Boolean ):number {
        let tNorm;  // Normalize time to 0-1
        let v;
        let T = ramptime + dwelltime;
        tNorm = (t%T)/T;
        
        if ( (t >= T) && (!repeating) ){
            // End of cycle and not repeating
            v = vTop;
        } else {
            
            if ( tNorm < 0 ){
                v = vBottom;
            } else if (tNorm < ramptime/T){
                v = vBottom + (vTop-vBottom)*tNorm/(ramptime/T);
            } else {
                v = vTop;
            }
        }
        //console.log("t = "+t+", tNorm = "+tNorm+", v = "+v);
        return v;
        
    }
    public static rampWaveN( t:number, ramptimeList:Array<number>, pointList:Array<number>, repeating:boolean ):number {
        let tNorm:number;  // Normalize time to 0-1
        let v:number, t1:number;
        let nSegments:number = ramptimeList.length - 1;
        let i:number;
        let iSeg:number = -1;
        let endTime:number = ramptimeList[ramptimeList.length-1];
        let ramptime:number;
        //console.log("nSegments = "+nSegments+", endTime = "+endTime);
        t1  = (t%endTime); // Time since start of this cycle
        
        for (i = 0; i <nSegments; i++){
            // Find which segment we are in
            if ( t1 >= ramptimeList[i] && t1<= ramptimeList[i+1]){
                iSeg = i;
                break;
            }
        }
        if (t <= 0){
            return pointList[0];
        }
        if ( t >= endTime  && (!repeating) ) {
            return  pointList[nSegments];
        }
        
        ramptime = ramptimeList[iSeg+1] - ramptimeList[iSeg];
        let tInRamp:number = t1 - ramptimeList[iSeg];
        
        tNorm = (tInRamp % ramptime)/ramptime;
        let vBottom:number = pointList[iSeg];
        let vTop:number = pointList[iSeg+1];
        
        if ( tNorm < 0 ){
            v = vBottom;
        } else if (tNorm < 1){
            v = vBottom + (vTop-vBottom)*tNorm;
        } else {
            v = vTop;
        }
        //console.log("t = "+t+", t1 = "+t1+", iSeg = "+iSeg+", tNorm = "+tNorm+", v = "+v);
        return v;
        
    }
    public static sineWave( t:number, period:number, vAmpl:number, vAvg:number, repeating:boolean  ):number {
        let phase:number;
        let v:number;
        if ( (t >= period) && (!repeating) ){
            v = vAvg;
        } else {
            phase = 2*Math.PI*(t%period)/period;
            v = vAvg + vAmpl*Math.sin( phase );
        }
        return v;
    
    }
    public static triangleWave(  t:number, period:number, vAmpl:number, vAvg:number, repeating:Boolean  ):number {
        let phase:number;
        let v:number;
        if ( (t >= period) && (!repeating) ){
            v = vAvg;
        } else {
            phase = 360*(t%period)/period;
            if ( phase <90 ){
                v = vAvg + vAmpl*(phase/90);
            } else if (phase < 180){
                v = vAvg + vAmpl*(180-phase)/90;
            } else if (phase < 270){
                v = vAvg - vAmpl*(phase-180)/90;
            } else {
                v = vAvg - vAmpl*(360-phase)/90;
            }
        }
        return v;
    }
    public static triangleWave2(  t:number, period:number, vBottom:number, vTop:number, repeating:Boolean  ):number {
        //return triangleWave(  t, period, (vTop - vBottom)/2, (vTop + vBottom)/2, repeating  );
        let phase:number;
        let v:number;
        let vpp:number = vTop - vBottom;
        if ( (t >= period) && (!repeating) ){
            v = vBottom;
        } else {
            phase = 360*(t%period)/period;
            if ( phase <180 ){
                v = vBottom + vpp*(phase/180);
            } else {
                v = vBottom + vpp*(360-phase)/180; // ph = 181, 
            }
        }
        return v;
    }
    public static triangleWave2Dwell( t:number, period:number, dwelltime:number, vBottom:number, vTop:number, repeating:Boolean ):number {
        let tNorm:number;  // Normalize time to 0-1
        let v:number;
        if (repeating){
            tNorm = (t%period)/period;
        } else {
            tNorm = t / period;
        }
        
        let tN2:number = 1 - dwelltime/period;
        let tN1:number = tN2/2;
        
        if ( tNorm >= 0 && tNorm< tN1 ){
            v =  vBottom + ( tNorm/tN1 )*(vTop - vBottom);
        } else if ( tNorm >= tN1 && tNorm < tN2 ){
            v =  vBottom + ( 1 - (tNorm - tN1)/(tN2-tN1) )*(vTop - vBottom);
        } else {
            v = vBottom;
        }
        //console.log("t = "+t+", tNorm = "+tNorm+", tN1 = "+tN1+", tN2 = "+tN2+", vBottom = "+vBottom+", vTop = "+vTop+", v = "+v);
        return v;
        
    }
    public static squareWave(  t:number, period:number, vAmpl:number, vAvg:number, repeating:Boolean  ):number {
        let phase:number;
        let v:number;
        if ( (t >= period) && (!repeating) ){
            v = vAvg;
        } else {
            phase = 360*(t%period)/period;
            if ( phase < 180){
                v = vAvg - vAmpl;
            } else {
                v = vAvg + vAmpl;
            }
        }
        return v;
    } 
     
    public static pointing_LHALimit(elMin:number, ESlat:number):number{
        // Brute force
        let LHA:number;
        let incr:number = 0.5;
        let trialEl:number;
        let lastLHA:number = 999;
        let found:boolean = false;

        for (LHA = 0; LHA <= LHA + 90; LHA += Math.abs(incr)){
            trialEl = this.pointing_el(LHA, ESlat, 0);
            //console.log("LHA = "+LHA+", trialEl = "+trialEl);
            if (trialEl < elMin){
                found = true;
                return lastLHA;
            }
            lastLHA = LHA;
        }
        if (!found){
            console.log("ERROR in UtilSP.pointing_LHALimit - did not reach elMin. "+
                " elMin = "+elMin+", ESlat = "+ESlat+", lastLHA = "+lastLHA);
            return 0;
        }
    }  
	public static pointing_az(ES_long:number, ES_lat:number, sat_long:number):number{
		// Returns azimuth degrees from due North in the range 0 to 360.  Eastwards is negative, westwards is positive.
		// Ref: Van Valkenburg, Reference Data for Radio Engineers, 9th Ed, p. 27-11.
		let lat:number = UtilSP.radians(ES_lat); // Latitude of Earth Station site. Positive = North
		let LHAdeg:number = UtilSP.pm180(ES_long - sat_long); // Local Hour Angle - longitude difference between satellite and Earth Station (East or West).
		
		let LHA:number = UtilSP.radians(LHAdeg);

		// Azimuth angle to satellite. East or West from South or North.
		let Tan_Phi:number = Math.tan(LHA) / Math.sin(lat);
		let azDeg1:number = UtilSP.degrees(Math.atan(Tan_Phi));
		//let LHAdeg = degrees(LHA);
		let azDeg:number;
		if (lat >= 0){
			// Northern hemisphere
			if (LHAdeg > 90){
				azDeg = azDeg1 + 360;
			} else if (LHAdeg >= -90) {
				azDeg = azDeg1 + 180;
			} else {
				azDeg = azDeg1;
			}
		} else {
			// Southern hemisphere
			if (LHAdeg > 90){
				azDeg = azDeg1 - 180;
			} else if (LHAdeg >= -90) {
				azDeg = azDeg1;
			} else {
				azDeg = azDeg1 + 180;
			}
			
		}
		//console.log("    satLong = "+sat_long+", LHA = "+degrees(LHA)+", azDeg1 = "+azDeg1+ ", azDeg = "+azDeg);
		return azDeg;
    }
	public static pointing_el(ES_long:number, ES_lat:number, sat_long:number):number{
		// Ref: Van Valkenburg, Reference Data for Radio Engineers, 9th Ed, p. 27-11.

		let r:number = UtilSP.earthRadiuskm; // Radius of the earth (km)
		let h:number = UtilSP.geoHeightkm; // Geostationary height (km)
		let lat:number = UtilSP.radians(ES_lat); // Latitude of Earth Station site (North or South).
		let LHA:number = UtilSP.radians(ES_long - sat_long); // Local Hour Angle - longitude difference between satellite and Earth Station (East or West).

		let cosbeta:number = Math.cos(lat) * Math.cos(LHA);
		let beta:number = Math.acos(cosbeta);
		let sinbeta:number = Math.sin(beta);
		let rphsq:number = (r+h)*(r+h);
		let d:number = Math.sqrt( r*r + rphsq - 2*r*(r+h)* cosbeta ); // in km
		let theta:number = Math.acos((r + h) * sinbeta / d);
		if (rphsq >= (r*r + d*d) ){
			theta = Math.abs(theta);
		} else {
			theta = -Math.abs(theta);
		}
		//console.log("cosbeta = "+cosbeta +", sinbeta = "+sinbeta +", beta(deg) = "+degrees(beta)+", d = "+d +", theta = "+theta);
		return UtilSP.degrees(theta);
    }   
    public static pointing_pol(ES_long:number, ES_lat:number, sat_long:number):number{
		// Clockwise looking towards satellite.  0 when sat_long = ES_long
		let lat = UtilSP.radians(ES_lat); // Latitude of Earth Station site (North or South).
		let LHA = UtilSP.radians(ES_long - sat_long); // Local Hour Angle - longitude difference between satellite and Earth Station (East or West).

		// Polarization angle from local vertical.
		let tan_Gamma = Math.sin(LHA) / Math.tan(lat);
		return UtilSP.degrees( Math.atan(tan_Gamma));
    }
	public static pointingO3b_az(ES_long:number, ES_lat:number, sat_long:number){
		// Azimuth is independent of satellite altitude.
		return  UtilSP.pointing_az(ES_long, ES_lat, sat_long);
	}  
	public static pointingO3b_el(ES_long:number, ES_lat:number, sat_long:number){
		// Based on pointing_el but with satellite height at O3b height
		let r = UtilSP.earthRadiuskm; // Radius of the earth (km)
		let h = UtilSP.O3bHeightkm; // O3b height (km)
		let lat = UtilSP.radians(ES_lat); // Latitude of Earth Station site (North or South).
		let LHA = UtilSP.radians(ES_long - sat_long); // Local Hour Angle - longitude difference between satellite and Earth Station (East or West).

		let cosbeta:number = Math.cos(lat) * Math.cos(LHA);
		let beta:number = Math.acos(cosbeta);
		let sinbeta:number = Math.sin(beta);
		let rphsq:number = (r+h)*(r+h);
		let d:number = Math.sqrt( r*r + rphsq - 2*r*(r+h)* cosbeta ); // in km
		let theta:number = Math.acos((r + h) * sinbeta / d);
		if (rphsq >= (r*r + d*d) ){
			theta = Math.abs(theta);
		} else {
			theta = -Math.abs(theta);
		}
		//console.log("cosbeta = "+cosbeta +", sinbeta = "+sinbeta +", beta(deg) = "+degrees(beta)+", d = "+d +", theta = "+theta+" = "+degrees(theta)+" el deg");
		return UtilSP.degrees(theta);
	}    
	public static pointingSatLong(elDeg:number, ES_long:number, ES_lat:number, orbitHeightAboveSurface_km:number):createjs.Point{
		// For equatorial orbit, returns the satellite longitude for a given elevation angle and site latitude.
        // Returns createjs.Point, x = satLongWdeg, y = satLongEdeg, W will be less than E
		// See RB Note1 FLA and AS notes, p. O3b Elevation
		let h:number = orbitHeightAboveSurface_km;
		let R:number = UtilSP.earthRadiuskm; // Radius of the earth (km)
		let theta:number = UtilSP.radians(elDeg); // Latitude of Earth Station site (North or South).
		let costheta:number = Math.cos(theta);
		let phi:number = UtilSP.radians(ES_lat);
		
		let Rphsq:number = (R+h)*(R+h);
		let a:number = Rphsq;
		let b:number = -2*R*(R+h)*costheta*costheta;
		let c:number = R*R*costheta*costheta + Rphsq*( costheta*costheta - 1);
		
		let cosbeta1:number = UtilSP.quadraticRoot1(a, b, c);
		let cosbeta2:number = UtilSP.quadraticRoot2(a, b, c);
		let beta1:number = Math.acos(cosbeta1);
		let beta2:number = Math.acos(cosbeta2);
		let beta1deg:number = UtilSP.degrees(beta1);
		let beta2deg:number = UtilSP.degrees(beta2);
		
		let cosLambda1:number = cosbeta1 / Math.cos(phi) ;
		let LHA1deg:number = UtilSP.degrees(Math.acos(cosLambda1));
		let cosLambda2:number = cosbeta2 / Math.cos(phi) ;  // Not sure why this root is not useful
		let LHA2deg:number = UtilSP.degrees(Math.acos(cosLambda2));
		
		let satLongEdeg:number = UtilSP.mod360(ES_long + LHA1deg);
		let satLongWdeg:number = UtilSP.mod360(ES_long - LHA1deg);
        if (satLongWdeg >= satLongEdeg){
            satLongWdeg -= 360;
        }
		return new createjs.Point(satLongWdeg, satLongEdeg); // W will be less than E
	}       
	public static quadraticRoot1(a:number, b:number, c:number):number{
		return (-b + Math.sqrt( b*b - 4*a*c) )/(2*a);
	}
	public static quadraticRoot2(a:number, b:number, c:number):number{
		return (-b - Math.sqrt( b*b - 4*a*c) )/(2*a);
	}    
	public static pointing_feedRotation(ES_long:number, ES_lat:number, sat_long:number, definedSense:string, actualSense:string ){
		// Returns feed rotation in degrees, where positive is CW when looking into the dish.
		let pol:number = UtilSP.pointing_pol(ES_long, ES_lat, sat_long);
		let rot:number;
		if (definedSense == actualSense ){
			rot = -pol;
		} else {
			rot = -pol + 90;
		}
		rot = UtilSP.pm180(rot);
		if (rot < -90 ){
			rot += 180;
		}
		if (rot > 90 ){
			rot -= 180;
		}
		return rot;
	}


    public static loss2beamwidth( L:number, hb3:number ):number{
        //Converts antenna off-axis loss to half beamwidth at that loss.  Requires 3-dB half beamwidth.
        // Loss (dB) L = 3 * (hb/hb3)^2
        // hb =  hb3 * sqrt(L/3)
        if( L < 0 ){
            console.log("Error in UtilSP.loss2beamwidth: parameter L less than zero.");
        }
        return hb3 * Math.sqrt( L/3 );
    } 
    public static HB3toGain(hb3:number){
        // Convert 3dB half bandwidth in degrees to on-axis gain in dB
        let b:number = 2*hb3; // Full 3dB beamwidth in deg
        let gain:number = 27000 / (b*b);
        let gain_dB:number = UtilSP.W2dBW(gain);
        return gain_dB;
    }
    public static gain2HB3(gain_dB:number){
        // Convert on-axis gain in dB to 3dB half bandwidth in degrees
        let gain = UtilSP.dBW2W(gain_dB);
        let hb3 = (Math.sqrt( 27000/ gain ))/2;
        return hb3;
    }    
    public static antennaPattern(angle_deg:number, dia_m:number, freq_MHz:number, eff:number, sidelobeLeveldB:number, type:string):number{
        /*
        Synthesizes a typical parabolic antenna gain pattern.
        angleDeg:  Angle off axis in degrees
        dia: Antenna diameter in meters
        efficiency: Antenna aperture efficiency (0 - 1)
        sidelobeLevel: Relative level of first sidelobe in dB, e.g. -18
        type:  "parabolic"  Uses parabolic main beam shape only.
               "sinXoverX"  Uses a simple sinX/X approximation
               "synth"      Synthesizes pattern using Brooker approximation
        */
        //let fGHz = freq_MHz / 1000;
        let gOnAxisdB:number = UtilSP.antGaindB( dia_m, freq_MHz, eff ); //20 * log10(Math.PI * dia_m * Math.sqrt(eff) * fGHz / 0.3);
        let a3:number = UtilSP.antBeamwidth( dia_m, freq_MHz, eff );// 3 dB half bandwidth
        let sl:number = -Math.abs(sidelobeLeveldB);
        return UtilSP.antennaPatternFromHBW( angle_deg, a3, gOnAxisdB, sl, type );
    }
    public static antGaindB( dia_m:number, freq_MHz:number, eff:number ):number{
        let a:number = 2 * Math.PI * (dia_m/2) * (freq_MHz/300 );
        let g:number = eff * a * a;
        let gdB:number = UtilSP.W2dBW( g );
        return gdB;
    } 

    public static antEllipticalEffectiveDia( majorDia_m:number, minorDia_m:number ):number{
        // Dia of a circle that has the same area as a given ellipse
        let area:number = this.ellipseArea(majorDia_m, minorDia_m);
        //A = PI r^2
        let r:number = Math.sqrt( area / Math.PI );
        return 2*r;
    } 
    public static antEllipticalGaindB( majorDia_m:number, minorDia_m:number, freq_MHz:number, eff:number ):number{
        let area:number = this.ellipseArea(majorDia_m, minorDia_m);
        let lambda:number = 300/freq_MHz;
        let g:number = 4 * Math.PI * eff * area / (lambda*lambda) ; // Ref Data For Radio Engineers, p 33-26
        let gdB:number = this.W2dBW( g );
        return gdB;
    }    
	public static ellipseArea(majorDia:number, minorDia:number):number{
		// Area of ellipse
		return (Math.PI * (majorDia/2)*(minorDia/2) );
	}         
    public static antBeamwidth( dia_m:number, freq_MHz:number, eff:number ):number{
        // Returns half beamwidth at 3dB point.
        let g:number = UtilSP.dBW2W( UtilSP.antGaindB( dia_m, freq_MHz, eff ) );
        return (Math.sqrt( 27000/ g ))/2;
    }
    public static antHalfBeamwidth( dia_m:number, freq_MHz:number, eff:number ):number{
        // Returns half beamwidth at 3dB point.
        return UtilSP.antBeamwidth(dia_m, freq_MHz, eff);
    } 
    public static antFullBeamwidthFromFormula( dia_m:number, freq_MHz:number, eff:number ):number{
        // Returns full beamwidth at 3dB point using the 15.7/(f d root-eff) formula
        return 15.7 / ( (freq_MHz/1000) * dia_m * Math.sqrt(eff));
    }          
    public static antennaPatternFromHBW( angle_deg:number, HalfBW3dB:number, gOnAxisdB:number, sidelobeLeveldB:number, type:string ):number{
        /*
        Synthesizes a typical parabolic antenna gain pattern.
        angleDeg:  Angle off axis in degrees
        HalfBW3dB: Half BW at 3dB point in deg
        gOnAxisdB: On-axis gain in dB. YOU MUST MAKE THIS CONSISTENT WITH HB3.
        sidelobeLevel: Relative level of first sidelobe in dB, e.g. -18
        type:  "parabolic"  Uses parabolic main beam shape only.
               "sinXoverX"  Uses a simple sinX/X approximation
               "synth"      Synthesizes pattern using Brooker approximation
        */
        //let fGHz = freq_MHz / 1000;
        let a:number = Math.abs(UtilSP.pm180(angle_deg));
        let gAbs:number = 0;
        let gRel:number;
        let a3:number = HalfBW3dB;
    
        if (type == "synth"){
            //let a3 = (4.53 / (dia_m * fGHz)) * Math.sqrt(3 / eff); // 3 dB half bandwidth

            let ana3:number = 2.5; // Ratio of first null angle to 3 dB half beamwidth
            let x:number = Math.abs((Math.PI / 2) * (1 / ana3) * a / a3);
            let zone:number = 0;

            let g580:number;
            if (x == 0) {
                gAbs = gOnAxisdB;
                zone = 0;
            } else if (x < Math.PI / 2) {
                // Main lobe
                //  up to a = a3*ana3
                let k1 = 3 / UtilSP.log10(Math.cos((Math.PI / 2) * (1 / ana3)));
                let p = 1;
                gRel = -k1 * UtilSP.log10( Math.pow(Math.abs(Math.cos(x)), p)  );
                gAbs = gRel + gOnAxisdB;
                zone = 1;
            } else if ( (x >= Math.PI / 2) && (x < Math.PI) ){
                // First sidelobe
                //   up to a = 2*a3*ana3
                gRel = 20 * UtilSP.log10(Math.abs(Math.sin(2 * x))) + sidelobeLeveldB;
                gAbs = gRel + gOnAxisdB;
                zone = 2;
            } else if (x >= Math.PI) {
                // Remaining sidelobes
                if (a <= 20) {
                    g580 = 29 - 25 * UtilSP.log10(a);
                } else if (a > 20 && a <= 26.5) {
                    g580 = -3.5;
                } else if (a > 26.5 && a <= 48) {
                    g580 = 32 - 25 * UtilSP.log10(a);
                } else {
                    g580 = -10;
                }
                gAbs = 20 * UtilSP.log10( Math.abs(Math.sin(2 * x))) + g580 - 2;
                zone = 3;
            }
            //console.log("In antennaPattern, zone = "+zone+", a = "+a+", x/Pi = "+(x/Math.PI)+", gAbs = "+gAbs);
        } else if (type == "sinXoverX"){
            // Sin(x)/x function
        
            let aS:number = 1.808 * a * Math.PI / (3*a3);
            let y:number;
            if (aS == 0){
                y = 1;
            }else{
                y = Math.abs( Math.sin(aS) / aS ); // Returns a value from 0 to 1.
            }
            let gReldB = UtilSP.W2dBW( y );
            gAbs = gReldB + gOnAxisdB;

        } else if (type == "parabolic"){
            gAbs = -UtilSP.beamwidth2loss( a, a3 ) + gOnAxisdB;
        }
        //console.log("Calculated gAbs = "+gAbs);
        return gAbs;

    }
	public static antennaNoiseTempInRain(rainFadedB:number, Tant:number, Tsky:number, 
        TgroundPhys:number, TatmPhys:number, TrainPhys:number){
		// For this analysis, see RB notebook 3 p. 170
		// rainFadedB  Rain loss of rain in dB, above clear sky atmospheric loss (positive)
		// Tant     noise temp of the antenna with no rain
		// Tsky     Noise temperature of the sky with no rain (T2 in notebook)
		// TgroundPhys  Physical temperature of the ground (T1 in notebook)
		// TatmPhys     Physical temperature of the atmosphere
		// TrainPhys    Physical temperature of the rain
		
		let Grain:number = UtilSP.dBW2W( -rainFadedB); // transmission coefficient (0-1)
		let Gatm:number = 1 - Tsky/TatmPhys; /// transmission through the atmosphere, no rain
		let TskyRain:number = Tsky*Grain + TrainPhys*(1 - Grain);  // T2' in notebook
		
		let TantRain:number = ( TgroundPhys*(Tant - Tsky) + TskyRain*(TgroundPhys - Tant) ) / (TgroundPhys - Tsky);
		return TantRain;
	} 
    public static antennaNoiseTempInRain2(rainFadedB:number, Tant:number, Tsky:number, 
        TgroundPhys:number, TrainPhys:number){
        // Same as antennaNoiseTempInRain but removed unused parameter TatmPhys
		// For this analysis, see RB notebook 3 p. 170
		// rainFadedB  Rain loss of rain in dB, above clear sky atmospheric loss (positive)
		// Tant     noise temp of the antenna with no rain
		// Tsky     Noise temperature of the sky with no rain (T2 in notebook)
		// TgroundPhys  Physical temperature of the ground (T1 in notebook)
		// TatmPhys     Physical temperature of the atmosphere
		// TrainPhys    Physical temperature of the rain
		
		let Grain:number = UtilSP.dBW2W( -rainFadedB); // transmission coefficient (0-1)
		let TskyRain:number = Tsky*Grain + TrainPhys*(1 - Grain);  // T2' in notebook
		let TantRain:number = ( TgroundPhys*(Tant - Tsky) + TskyRain*(TgroundPhys - Tant) ) / (TgroundPhys - Tsky);
		return TantRain;
    }
 
    public static skinDepth_mm_Cu(fGHz:number):number{
	     /*
        From Microwaves101:
        d = sqrt( 2p / (2 pi f ur u0) )
        u0 = 4 pi x 1E-7  H/m
        ur = 1 for most conductors
        p = resistivity ohm-m.  Cu = 1.673E-8
        */
	    
        // From Van Valkenburg, Ref Data fro Radio Engineers, p. 6-7
   		// var f = fGHz * 1E6;
		// return (2.60 / Math.sqrt(f) );

        let p:number = 1.673E-8;
        let u0:number = 4 * Math.PI * 1E-7;
        let ur:number = 1;
        let f_Hz = fGHz * 1E9;

        let d_m:number = Math.sqrt( 2*p / (2 * Math.PI * f_Hz * ur * u0) );
        return d_m * 1000;
	}  
	public static ellipseR(thetaDeg:number, majorDia:number, minorDia:number){
		// Radius from center to ellipse.
		let ct = Math.cos(UtilSP.radians(thetaDeg));
		let st = Math.sin(UtilSP.radians(thetaDeg));
		let a = majorDia/2;
		let b = minorDia/2;
		let r = a*b / Math.sqrt( b*b*ct*ct + a*a*st*st );
		return r;
    }   
    public static pointing_scannedBeamAzEl(mainBeamAz:number, mainBeamEl:number, 
        scanBeamDistanceDeg:number, tiltDeg:number, scanBeamRadiusDeg:number, scanBeamAngleDeg:number):Array<number>{
		/* See TestPointing_scannedBeamEl.fla for spherical geometry diagrams
		
		Returns the az-el of point p, where M is the main beam, S is the scanned beam. 
		
		                  S
		                 /  \
		                /    p
		              M
		
		   S is defined relative to M by scanBeamDistanceDeg, tiltDeg
		   p is defined relative to s by scanBeamRadiusDeg, scanBeamAngleDeg
		*/
		let A1E1:Array<number> = [];
		let A2E2:Array<number> = [];
		
		// Get az-el of center of a scanned beam:
		A1E1 = UtilSP.scanTilt2AzEl(mainBeamAz, mainBeamEl, scanBeamDistanceDeg, tiltDeg);
		if (isNaN(A1E1[0]) || isNaN(A1E1[1])){
			console.log("Error in  pointing_scannedBeamAzEl: NaN found in A1E1.  mainBeamAz = "+mainBeamAz+", mainBeamEl = "+mainBeamEl+", scanBeamDistanceDeg = "+scanBeamDistanceDeg+", tiltDeg = "+tiltDeg);
		}
		// Get az-el at a given point away from the result: 
		A2E2 = UtilSP.scanTilt2AzEl( A1E1[0], A1E1[1], scanBeamRadiusDeg, scanBeamAngleDeg );
		if (isNaN(A2E2[0]) || isNaN(A2E2[1])){
			console.log("Error in  pointing_scannedBeamAzEl: NaN found in A2E2.  mainBeamAz = "+mainBeamAz+", mainBeamEl = "+mainBeamEl+", scanBeamDistanceDeg = "+scanBeamDistanceDeg+", tiltDeg = "+tiltDeg+", A1E1[0] = "+ A1E1[0]+", A1E1[1] ="+ A1E1[1]);
		}
		return A2E2;
    } 
    public static scanTilt2AzEl(A0deg:number, E0deg:number, Sdeg:number, Tdeg:number):Array<number>{
		/*
		A0 & E0 are the azimuth & elevation of the antenna axis beam.
		Sdeg is scan offset.  Sdeg positive moves the beam to the right along the arc (with Tdeg = 90).
		Tdeg is tilt following the DIRECTV convention, i.e. 
			Tdeg = 90 deg:  dish major axis is horizontal, locus of beams is horizontal.
			Tdeg < 90 deg: locus of beams is rotated clockwise in the sky.

		Returns an array.  Element 0 is azimuth of the scanned beam.  Element 1 is the elevation.
		See TestPointing_scannedBeamEl.fla for spherical geometry diagrams
		*/
		
		let azEl:Array<number> = [];
		/*
		Get Q1 from: 
		sin (Q1) = sin(T) sin(S)
		Get E1 from:
		cos(S) = cos(E0-E1) cos(Q1)
		cos(E0-E1)  = cos(S) / cos(Q1)
		E1 = E0 - acos[  cos(S) / cos(Q1) ]
		Get A1 from:
		sin(Q1/2) = sin[ (A1-A0)/2] sin(E1')
		(A1-A0)/2 = asin[ sin(Q1/2)  / sin(E1') ]
		A1 = A0 + 2*asin[ sin(Q1/2) / sin(E1') ]
		*/
		
		let A0:number = UtilSP.radians(A0deg);
		let E0:number = UtilSP.radians(E0deg);
		let S:number = UtilSP.radians(Sdeg);
		let Tpdeg:number = UtilSP.mod360( Tdeg);
		let Tp:number = UtilSP.radians(Tpdeg);
		
		let Q1:number;
		let E1:number;
		let Edelta:number;
		if (Tpdeg == 90){
			Q1= S;
			Edelta = 0;
		} else if ( Tpdeg == 270){
			Q1= -S;
			Edelta = 0;
		} else {
			Q1 = Math.asin( Math.sin(Tp) * Math.sin(S) ); // Tp = 90 deg; Q1 = S
			Edelta = Math.acos(  Math.cos(S) / Math.cos(Q1) );
		}
		
		if ( S > 0 ){
			if ( Tpdeg <= 90 || Tpdeg >= 270){
				E1 = E0 - Edelta ;
			} else {
				E1 = E0 + Edelta ;
			}
		} else {
			if ( Tpdeg <= 90 || Tpdeg >= 270){
				E1 = E0 + Edelta ;
			} else {
				E1 = E0 - Edelta ;
			}
			
		}
		let	A1 = A0 + 2*Math.asin( Math.sin(Q1/2) / Math.sin( (Math.PI/2)-E1) );
		//console.log("A0 = "+sprintf3("%7.1f", degrees(A0))+", E0 = "+sprintf3("%7.1f", degrees(E0))+", S = "+sprintf3("%7.1f", degrees(S))+", Tp = "+sprintf3("%7.1f", Tpdeg)+", Q1 = "+sprintf3("%7.1f", degrees(Q1))+", A1 = "+sprintf3("%7.1f", degrees(A1))+", E1 = "+sprintf3("%7.1f", degrees(E1)) );
		azEl[0] = UtilSP.degrees(A1);
		azEl[1] = UtilSP.degrees(E1);
		if (isNaN(A1) || isNaN(E1)){
			console.log("ERROR in UtilSP.scanTilt2AzEl: A0deg = "+A0deg+", E0deg = "+E0deg+", Sdeg = "+Sdeg+", Tdeg = "+Tdeg+", A1 = "+A1+", E1 = "+E1+", Edelta = "+Edelta );
		}
		return azEl;
    } 
    public static ratioAbs(a:number, b:number):number{
		// Abs value of the ratio, always >= 0.  e.g. ratioAbs(1, 1.2) = 0.2
		// 123, 0 --> 1e99
		// 0, 0 --> 0
		// 0, 123 --> 1e99
		
		if (b == 0 && a == 0){
			return 0;
		} else if (b == 0 && a!= 0){
			return 1e99;
		} else if (a == 0 && b!= 0){
			return 1e99;
		} else {
			let r:number = Math.abs(a) / Math.abs(b);
			if (r < 1 ){
				r = 1/r;
			}
			//console.log("a = "+a+", b = "+b+", r = "+r);
			return r-1;
		}
	}
    public static rss(a:number, b:number){
		// sqrt of (a^2 + b^2)
		return (Math.sqrt( a*a + b*b ) );
    }
	public static pointing_lossToTarget(az:number, el:number, targetAz:number, targetEl:number, hb3:number){
		// Pointing loss to a target satellite az-el from current antena direction az/el 
		let da:number =  UtilSP.pointing_diff_angle(az, el, targetAz, targetEl );
		return UtilSP.beamwidth2loss( da, hb3 );
    }  
	public static pointing_diff_angle( az1:number, el1:number, az2:number, el2:number){
		// Returns the angle between two pointing directions, all in degrees.
		// cos c = cos a . cos b, where a and b are the sides of spherical right triangle; c is the hypotenuse
		let daz:number = UtilSP.radians(az2-az1);
		let del:number = UtilSP.radians(el2-el1);
		return UtilSP.degrees(  Math.acos( Math.cos(daz) * Math.cos(del) ) );
    }  
	public static pointing_slantrange(ES_long:number, ES_lat:number, sat_long:number){
		let r:number = UtilSP.earthRadiuskm; // Radius of the earth (km)
		let h:number = UtilSP.geoHeightkm; // Geostationary height (km)
		let lat:number = UtilSP.radians(ES_lat); //Latitude of Earth Station site (North or South).
		let LHA:number = UtilSP.radians(ES_long - sat_long); // Local Hour Angle - longitude difference between satellite and Earth Station (East or West).
		let cosbeta:number = Math.cos(lat) * Math.cos(LHA);
		return Math.sqrt( r*r + (r+h)*(r+h) - 2*r*(r+h)* cosbeta ); // in km
	} 
	public static freeSpaceLoss(freq_MHz:number, distance_km:number):number{
		let lambda:number = 3e8/ ( freq_MHz * 1e6 ); // meters
		let d:number = distance_km * 1000; // meters
		let loss:number = 20 * UtilSP.log10( 4 * Math.PI * d / lambda ); // dB
		return loss;
	}  
    public static pathLoss_MHz_km (freq_MHz:number, distance_km:number):number{
        return UtilSP.freeSpaceLoss(freq_MHz, distance_km);
    }
    public static pathLoss (freq_Hz:number, distance_m:number):number{
        return UtilSP.pathLoss_MHz_km(freq_Hz*1e-6, distance_m*1e-3);
    }
    public static spreadingLoss(d:number):number{
        let Ls_dB:number = 10 * UtilSP.log10( 4 * Math.PI * d * d ); // Spreading loss
        return Ls_dB;
    }
	public static EIRP2PFD(EIRP_dBW:number, distance_km:number):number{
		let d:number = distance_km * 1000; // meters
        //let Ls_dB:number = 10 * UtilSP.log10( 4 * Math.PI * d * d ); // Spreading loss
        //let PFD:number = EIRP_dBW - Ls_dB; // W/m2
        let PFD:number = EIRP_dBW - UtilSP.spreadingLoss(d); // W/m2
		return PFD;
	}         
    public static beamwidth2loss( hb:number, hb3:number ):number{
        //Converts antenna half beamwidth angle to off-axis loss.  Requires 3-dB half beamwidth.
        // Loss (dB) L = 3 * (hb/hb3)^2
        return 3 * (hb*hb)/(hb3*hb3);
    }
	public static pointing_loss(freq_GHz:number, dia_m:number, eff:number, angle_deg:number){
		//Approximate off-axis loss for a typical parabolic antenna.
		// Returns a positive number
		return 0.0487 * Math.pow((freq_GHz * dia_m), 2) * eff * angle_deg * angle_deg;
	}
	public static pointing_errorBeamBalance( hbw3:number, L:number, E:number){
		// hbw = 3dB half beamwidth; L = pointing loss to ref level; E = meter error 
		// From RB paper
		let errAng:number = (hbw3 / (2*Math.sqrt(3) ) )* ( Math.sqrt(L+E) - Math.sqrt(L-E) );
		return errAng;
	}
	public static pointing_angle(freq_GHz:number, dia_m:number, eff, loss:number){
		//Approximate off-boresight angle for a given off-axis loss for a typical parabolic antenna.
		return Math.sqrt(1 / 0.0487) * Math.sqrt(loss) / (dia_m * freq_GHz * Math.sqrt(eff));
	}
	public static randomESlongitude10(ESlat:number, satLong:number):number{
		// Returns random latitude for elevation at least 10 degrees.
		// See testUtil3PointingAngles.fla for table.
		let latAbs:number = Math.abs(ESlat);
		let LHAmax:number;
		if (latAbs <= 20 ){
			LHAmax = 70;
		} else if (latAbs <= 50 ){
			LHAmax = 60;
		} else if (latAbs <= 60 ){
			LHAmax = 50;
		} else if (latAbs <= 65 ){
			LHAmax = 40;
		} else if (latAbs <= 70 ){
			LHAmax = 20;
		} else {
			LHAmax = NaN;
			console.log("Error in randomESlongitude10: Latitude is too high for 10 deg elevation.");
			return NaN;
		}
		let ESlong:number = satLong -LHAmax + Math.random()*2*LHAmax;
		ESlong = UtilSP.pm180(ESlong);
		return ESlong;
	}
	public static randomESlongitude20(ESlat:number, satLong:number):number{
		// Returns random latitude for elevation at least 20 degrees.
		// See testUtil3PointingAngles.fla for table.
		let latAbs:number = Math.abs(ESlat);
		let LHAmax:number;
		if      (latAbs <= 20 ){ LHAmax = 60;} 
		else if (latAbs <= 42 ){ LHAmax = 50; } 
		else if (latAbs <= 53 ){ LHAmax = 40; } 
		else if (latAbs <= 60 ){ LHAmax = 20;} 
		else {
			LHAmax = NaN;
			//console.log("Error in randomESlongitude20: Latitude = "+latAbs+" is too high for 20 deg elevation.");
			return NaN;
		}
		let ESlong:number = satLong -LHAmax + Math.random()*2*LHAmax;
		ESlong = UtilSP.pm180(ESlong);
		//console.log("In randomESlongitude20: satLong "+satLong+", latAbs = "+latAbs+", LHAmax = "+LHAmax+", ESlong = "+ESlong);
		return ESlong;
	}
    public static c2rgba(col:string, alpha?:number):string{
        // Generates hex rgba (color+alpha) from a color string and alpha number
        // col can be either a valid css color string, or a hex rgb in format #nnnnnn
        // alpha is 0-1
        if (col === undefined){
            console.log("ERROR in UtilSP.c2rgba: col is undefined.  Forcing to black.");
            col = "black";
        }
        let cssColors = {
            "aliceblue": "#f0f8ff",
            "antiquewhite": "#faebd7",
            "aqua": "#00ffff",
            "aquamarine": "#7fffd4",
            "azure": "#f0ffff",
            "beige": "#f5f5dc",
            "bisque": "#ffe4c4",
            "black": "#000000",
            "blanchedalmond": "#ffebcd",
            "blue": "#0000ff",
            "blueviolet": "#8a2be2",
            "brown": "#a52a2a",
            "burlywood": "#deb887",
            "cadetblue": "#5f9ea0",
            "chartreuse": "#7fff00",
            "chocolate": "#d2691e",
            "coral": "#ff7f50",
            "cornflowerblue": "#6495ed",
            "cornsilk": "#fff8dc",
            "crimson": "#dc143c",
            "cyan": "#00ffff",
            "darkblue": "#00008b",
            "darkcyan": "#008b8b",
            "darkgoldenrod": "#b8860b",
            "darkgray": "#a9a9a9",
            "darkgreen": "#006400",
            "darkgrey": "#a9a9a9",
            "darkkhaki": "#bdb76b",
            "darkmagenta": "#8b008b",
            "darkolivegreen": "#556b2f",
            "darkorange": "#ff8c00",
            "darkorchid": "#9932cc",
            "darkred": "#8b0000",
            "darksalmon": "#e9967a",
            "darkseagreen": "#8fbc8f",
            "darkslateblue": "#483d8b",
            "darkslategray": "#2f4f4f",
            "darkslategrey": "#2f4f4f",
            "darkturquoise": "#00ced1",
            "darkviolet": "#9400d3",
            "deeppink": "#ff1493",
            "deepskyblue": "#00bfff",
            "dimgray": "#696969",
            "dimgrey": "#696969",
            "dodgerblue": "#1e90ff",
            "firebrick": "#b22222",
            "floralwhite": "#fffaf0",
            "forestgreen": "#228b22",
            "fuchsia": "#ff00ff",
            "gainsboro": "#dcdcdc",
            "ghostwhite": "#f8f8ff",
            "goldenrod": "#daa520",
            "gold": "#ffd700",
            "gray": "#808080",
            "green": "#008000",
            "greenyellow": "#adff2f",
            "grey": "#808080",
            "honeydew": "#f0fff0",
            "hotpink": "#ff69b4",
            "indianred": "#cd5c5c",
            "indigo": "#4b0082",
            "ivory": "#fffff0",
            "khaki": "#f0e68c",
            "lavenderblush": "#fff0f5",
            "lavender": "#e6e6fa",
            "lawngreen": "#7cfc00",
            "lemonchiffon": "#fffacd",
            "lightblue": "#add8e6",
            "lightcoral": "#f08080",
            "lightcyan": "#e0ffff",
            "lightgoldenrodyellow": "#fafad2",
            "lightgray": "#d3d3d3",
            "lightgreen": "#90ee90",
            "lightgrey": "#d3d3d3",
            "lightpink": "#ffb6c1",
            "lightsalmon": "#ffa07a",
            "lightseagreen": "#20b2aa",
            "lightskyblue": "#87cefa",
            "lightslategray": "#778899",
            "lightslategrey": "#778899",
            "lightsteelblue": "#b0c4de",
            "lightyellow": "#ffffe0",
            "lime": "#00ff00",
            "limegreen": "#32cd32",
            "linen": "#faf0e6",
            "magenta": "#ff00ff",
            "maroon": "#800000",
            "mediumaquamarine": "#66cdaa",
            "mediumblue": "#0000cd",
            "mediumorchid": "#ba55d3",
            "mediumpurple": "#9370db",
            "mediumseagreen": "#3cb371",
            "mediumslateblue": "#7b68ee",
            "mediumspringgreen": "#00fa9a",
            "mediumturquoise": "#48d1cc",
            "mediumvioletred": "#c71585",
            "midnightblue": "#191970",
            "mintcream": "#f5fffa",
            "mistyrose": "#ffe4e1",
            "moccasin": "#ffe4b5",
            "navajowhite": "#ffdead",
            "navy": "#000080",
            "oldlace": "#fdf5e6",
            "olive": "#808000",
            "olivedrab": "#6b8e23",
            "orange": "#ffa500",
            "orangered": "#ff4500",
            "orchid": "#da70d6",
            "palegoldenrod": "#eee8aa",
            "palegreen": "#98fb98",
            "paleturquoise": "#afeeee",
            "palevioletred": "#db7093",
            "papayawhip": "#ffefd5",
            "peachpuff": "#ffdab9",
            "peru": "#cd853f",
            "pink": "#ffc0cb",
            "plum": "#dda0dd",
            "powderblue": "#b0e0e6",
            "purple": "#800080",
            "rebeccapurple": "#663399",
            "red": "#ff0000",
            "rosybrown": "#bc8f8f",
            "royalblue": "#4169e1",
            "saddlebrown": "#8b4513",
            "salmon": "#fa8072",
            "sandybrown": "#f4a460",
            "seagreen": "#2e8b57",
            "seashell": "#fff5ee",
            "sienna": "#a0522d",
            "silver": "#c0c0c0",
            "skyblue": "#87ceeb",
            "slateblue": "#6a5acd",
            "slategray": "#708090",
            "slategrey": "#708090",
            "snow": "#fffafa",
            "springgreen": "#00ff7f",
            "steelblue": "#4682b4",
            "tan": "#d2b48c",
            "teal": "#008080",
            "thistle": "#d8bfd8",
            "tomato": "#ff6347",
            "turquoise": "#40e0d0",
            "violet": "#ee82ee",
            "wheat": "#f5deb3",
            "white": "#ffffff",
            "whitesmoke": "#f5f5f5",
            "yellow": "#ffff00",
            "yellowgreen": "#9acd32"
            }

        let rgb:string;
        let rgb2:string;
        if (col.substring(0,5) == "rgba("){
            return col; // Already converted
        } else if ( col.substring(0,1) == "#"){
            //console.log("fn = "+ UtilSP.hexToRgbA(col));
            rgb = UtilSP.hexToRgbA(col);  // e.g. "11,22,33"
        } else {
            rgb2 = cssColors[col.toLowerCase()];

            if (rgb2 == undefined){
                console.log("ERROR in UtilSP.c2rgba: "+col+" is not a valid color. Using black.");
                rgb =  UtilSP.hexToRgbA("#000000");
            } else {
                rgb = UtilSP.hexToRgbA(rgb2);
            }
        }
        if (alpha == undefined){
            alpha = 1;
        }
        let a:string = String(alpha);
        let retval:string = "rgba("+rgb+","+a+")";

        //console.log("In c2rgba, col = "+col+", alpha = "+alpha+", retval = "+retval);
        return retval;

    } 
 
    public static hexToRgbA(hex:string):string{
        // From https://stackoverflow.com/questions/21646738/convert-hex-to-rgba
        //If you write your own code, remember hex color shortcuts (eg., #fff, #000)

        let c;
        if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
            c= hex.substring(1).split('');
            if(c.length== 3){
                c= [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c= '0x'+c.join('');
            //return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',1)';
            let retval:string = [(c>>16)&255, (c>>8)&255, c&255].join(',');
            return retval;
        } else {
            console.log("ERROR in UtilSP.hexToRgbA: cannot parse hex = "+hex+". Returning black.");
            return "0,0,0"
        }
    } 
    public static wavelength2color(wavelength:number):string{
        //Takes optical wavelength in nm (380-780 ) and generates color string of that temperature
        // Range 380 to 780 nm, indigo to dark red. pale green is 500 nm.
        // From https://academo.org/demos/wavelength-to-colour-relationship/  and linked codepen
        let Gamma:number = 0.80,
        IntensityMax:number = 255,
        factor:number, red:number, green:number, blue:number;
       
        if((wavelength >= 380) && (wavelength<440)){
            red = -(wavelength - 440) / (440 - 380);
            green = 0.0;
            blue = 1.0;
        }else if((wavelength >= 440) && (wavelength<490)){
            red = 0.0;
            green = (wavelength - 440) / (490 - 440);
            blue = 1.0;
        }else if((wavelength >= 490) && (wavelength<510)){
            red = 0.0;
            green = 1.0;
            blue = -(wavelength - 510) / (510 - 490);
        }else if((wavelength >= 510) && (wavelength<580)){
            red = (wavelength - 510) / (580 - 510);
            green = 1.0;
            blue = 0.0;
        }else if((wavelength >= 580) && (wavelength<645)){
            red = 1.0;
            green = -(wavelength - 645) / (645 - 580);
            blue = 0.0;
        }else if((wavelength >= 645) && (wavelength<781)){
            red = 1.0;
            green = 0.0;
            blue = 0.0;
        }else{
            red = 0.0;
            green = 0.0;
            blue = 0.0;
        }

        // Let the intensity fall off near the vision limits
        if((wavelength >= 380) && (wavelength<420)){
            factor = 0.3 + 0.7*(wavelength - 380) / (420 - 380);
        }else if((wavelength >= 420) && (wavelength<701)){
            factor = 1.0;
        }else if((wavelength >= 701) && (wavelength<781)){
            factor = 0.3 + 0.7*(780 - wavelength) / (780 - 700);
        }else{
            factor = 0.0;
        }

        if (red !== 0){
            red = Math.round(IntensityMax * Math.pow(red * factor, Gamma));
        }
        if (green !== 0){
            green = Math.round(IntensityMax * Math.pow(green * factor, Gamma));
        }
        if (blue !== 0){
            blue = Math.round(IntensityMax * Math.pow(blue * factor, Gamma));
        }
        return this.rgbArray2HexString([red,green,blue]);           
    }  


    public static hslToRgb(h:number, s:number, l:number):Array<number> {
        // From https://stackoverflow.com/questions/2353211/hsl-to-rgb-color-conversion
        //  * Converts an HSL color value to RGB. Conversion formula
        //  * adapted from https://en.wikipedia.org/wiki/HSL_color_space.
        //  * Assumes h, s, and l are contained in the set [0, 1] and
        //  * returns r, g, and b in the set [0, 255].
        //  *
        //  * @param   {number}  h       The hue
        //  * @param   {number}  s       The saturation
        //  * @param   {number}  l       The lightness
        //  * @return  {Array}           The RGB representation
        //  */
        let r:number, g:number, b:number;

        if (s === 0) {
            r = g = b = l; // achromatic
        } else {
            const q:number = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p:number = 2 * l - q;
            r = this.hueToRgb(p, q, h + 1/3);
            g = this.hueToRgb(p, q, h);
            b = this.hueToRgb(p, q, h - 1/3);
        }

        return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    }

    public static hueToRgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1/6) return p + (q - p) * 6 * t;
        if (t < 1/2) return q;
        if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }
    public static HSLToHex(hsl: { h: number; s: number; l: number }): string {
        // From https://www.jameslmilner.com/posts/converting-rgb-hex-hsl-colors/
        const { h, s, l } = hsl;

        const hDecimal = l / 100;
        const a = (s * Math.min(hDecimal, 1 - hDecimal)) / 100;
        const f = (n: number) => {
            const k = (n + h / 30) % 12;
            const color = hDecimal - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);

            // Convert to Hex and prefix with "0" if required
            return Math.round(255 * color)
            .toString(16)
            .padStart(2, "0");
        };
        return `#${f(0)}${f(8)}${f(4)}`;
    }


    public static number2HexString(val:number):string{
        //converts a decimal number into hex format
        let hex:string =  val.toString(16);
        if (hex.length < 2){
            hex = "0" + hex;
        }
        return hex;
    }
    public static rgbArray2HexString(color:Array<number>):string{
        //takes an 3 element array (r,g,b) and returns a hexadecimal color string
        let hexString:string = '#';
        for (var i = 0 ; i < 3 ; i++){
            hexString += this.number2HexString(color[i]);
        }
        return hexString;    
    }    

   public static W2dBm( x:number ):number {
        // Converts Watts to dBm
        return 30 + 10 * Math.log(x) / Math.LN10;
    }
    public static W2dBW( x:number ):number {
        // Converts Watts to dBW
        return 10 * Math.log(x) / Math.LN10;
    }
    public static Pratio2dB( x:number ):number {
        // Converts power ratio to dB
        return 10 * Math.log(x) / Math.LN10;
    }    
    public static dBW2W( x:number ):number {
        // Converts dBW to Watts
        return Math.pow(10, x/10);
    }
    public static dB2Pratio( x:number ):number {
        // Converts dB to power ratio
        return Math.pow(10, x/10);
    }    
    public static dBm2W( x:number ):number {
        // Converts dBW to Watts
        return Math.pow(10, (x - 30) / 10);
    }
     public static log10( x:number ):number {
        // Base 10 log
        return Math.log(x) / Math.LN10;
    }
    public static tenlog( x:number ) :number{
        // 10 x Base 10 log
        return 10*Math.log(x) / Math.LN10;
    }
    public static log10a( x:number ):number {
        // Base 10 log with large neg number for zero
        if (x == 0){
            return -99999;
        } else {
            return Math.log(x) / Math.LN10;
        }
    } 
    public static log2(x:number ):number {
        return Math.log(x) / Math.log(2);
    }
    public static Vrms2dBm( Vrms:number, Z:number ):number{
        return (20*UtilSP.log10(Vrms) - 10*UtilSP.log10(Z) + 30);
    }
    public static Vratio2dB( Vratio:number ):number{
        return (20*UtilSP.log10(Vratio) );
    }
    public static dB2Vratio( dB:number ):number{
        return ( Math.pow(10, dB/20) );
    }
    public static reflCoeff2RLdB( gamma:number ):number{
        return ( -20 * UtilSP.log10a(gamma) ); // RL is positive
    }
    public static RLdB2reflCoeff( RL:number ):number{
        return ( Math.pow(10, -RL/20) ); // RL is positive
    }
    public static VAR2XPDdB(VAR:number):number{
        let xpd_db:number = 20*UtilSP.log10a( (VAR+1)/(VAR-1) );
        return xpd_db;
    }
    public static XPDdB2VAR(xpd_db:number):number{
        let x:number = UtilSP.dB2Vratio(xpd_db);
        let VAR:number = (x+1)/(x-1);
        return VAR;
    }    
    public static sumdBPowers( a:Array<number> ):number{
        // Adds up all the members of the array in power, assuming that are in dB units.
        /// Returns a value in the same dB units.
        let Psum:number = 0;
        for (let i:number=0; i<a.length; i++){
            Psum +=  Math.pow(10,  (a[i] / 10) );
        }
        return (  10 * Math.log(Psum) / Math.LN10 );
    }
    public static sum2CWsignals( p1dBx:number, ph1deg:number, p2dBx:number, ph2deg:number):number{
        // Sums two CW signals both in dBx; returns power in dBx
        let v1:number = UtilSP.dB2Vratio(p1dBx);
        let v1x:number = v1*Math.cos(UtilSP.radians(ph1deg));
        let v1y:number = v1*Math.sin(UtilSP.radians(ph1deg));
        let v2:number = UtilSP.dB2Vratio(p2dBx);
        let v2x:number = v2*Math.cos(UtilSP.radians(ph2deg));
        let v2y:number = v2*Math.sin(UtilSP.radians(ph2deg));
        let vSumx:number = v1x + v2x;
        let vSumy:number = v1y + v2y;
        let vSum:number = Math.sqrt( vSumx*vSumx + vSumy*vSumy );
        return (  UtilSP.Vratio2dB( vSum ) );
    }

    public static i2f(i:number, fstart:number, fstop:number, nfreqs:number):number{
        let delta:number = (fstop-fstart)/ (nfreqs-1);
        //let f:number = fstart + (fstop-fstart)*i / (nfreqs-1);
        let f:number = fstart + delta*i
        return f;
    }
    public static f2i(f:number, fstart:number, fstop:number, nfreqs:number):number{
        let delta:number = (fstop-fstart)/ (nfreqs-1);
        //let i:number = (f - fstart)*(nfreqs-1)/(fstop-fstart);
        let i:number = (f - fstart) / delta;
        i = Math.round(i)
        //console.log("In f2i, f = "+f+"; fstart = "+f+", fstop = "+fstop+", nfreqs = "+nfreqs+", delta = "+delta+" --> i = "+i);
        //debugger
        //let fcheck = this.i2f(i, fstart, fstop, nfreqs);
        //console.log("CHECK: fcheck = "+fcheck);
        return i;
    }

	public static clipper(parameter:string, Input_power_dB:number, Small_signal_gain_dB:number, Limit_level_dB:number){
		/* Calculates large signal gain of an ideal clipper.
		Clips the voltage or current at a defined level such that output power approaches Limit_level_dB

		Inputs:
			Parameter
				"gain" returns large signal gain
				"Pout" returns output power
			Input_power_dBW = input power in dB (same units as limit level)
			Small_signal_gain_dB = small signal gain of the clipper
			Limit_level_dB = the output power in limiting
		Returns:
			Large signal gain at given input power. (Same units as input power and limit level)
		*/
		let Theta_c:number;
		let pi = Math.PI;
		
		let A:number = Math.sqrt(2 * Math.pow(10,(Input_power_dB / 10))); // Input amplitude
		let G:number = Math.pow(10, (Small_signal_gain_dB / 20)); //Voltage gain
		let k:number = Math.pow(10, (Limit_level_dB / 20)); // Output voltage clipping level in a 1 ohm system

		if ( (A * G) > k) {
    		Theta_c = Math.asin( k / (A * G));
		}else{
    		Theta_c = pi / 2;
		}

		let p:number = A*A * G*G * ((Theta_c / pi) - (Math.sin(2*Theta_c)) / (2*pi)) + k*k*(1 - 2*Theta_c/pi);

		let P_dB:number = 10 * Math.log10(p);

		if (parameter == "Pout"){ 
    		return P_dB;
		} else if (parameter == "gain") {
    		return (P_dB - Input_power_dB);
		} else {
    		console.log( "Error - invalid parameter type in function Clipper: " + parameter );
		}
	}      
    public static randGaussian():number {
        const randGaussian_c_0:number = 2.515517;
        const randGaussian_c_1:number = 0.802853;
        const randGaussian_c_2:number = 0.010328;
        const randGaussian_d_1:number = 1.432788;
        const randGaussian_d_2:number = 0.189269;
        const randGaussian_d_3:number = 0.001308;

        let x:number, t:number, result:number;
        /*
        From Gaussian distribution FAQ by John D'Errico.
        6. How do you generate a normally distributed random variable?
        
        There are several good ways to do this, some better than others. It is assumed that the user has available a good uniform pseudo-random deviate 
        generator available. This is the starting point	for all such approaches.
        
        A good and logical way to generate a normal random deviate is to look back to the answer to question (5). Simply generate a single 
        uniform [0,1] random deviate X, and then invert the cumulative normal at that point. If the inverse is an accurate one, then that number 
        will indeed be a pseudo-random normal deviate. This method will be as fast and as good as is the approximation you choose for
        the inverse of the cumulative normal.
        
        5. What is a good approximation to the inverse of the cumulative normal distribution function?
        
        Mathematically we can write this as:  Find X such that Q(X) = p for any 0 < p < 1. (Note: this computes an upper tail probability.)
        
        Again, it is not possible to write this as a closed form expression, so we resort to approximations. Because of the symmetry of the normal distribution, 
        we need only consider 0 < p < 0.5. If you have p > 0.5,	then apply the algorithm below to q = 1-p, and then negate the value for X obtained. (This 
        approximation is also from Abramowitz and Stegun.)
        
        t = sqrt[ ln(1/p^2) ]
        
                     c_0 + c_1*t + c_2*t^2
        X = t -  ------------------------------
                 1 + d_1*t + d_2*t^2 + d_3*t^3
        
        c_0 = 2.515517
        c_1 = 0.802853
        c_2 = 0.010328
        
        d_1 = 1.432788
        d_2 = 0.189269
        d_3 = 0.001308
        
        See Abramowitz and Stegun; Press, et al.
        */
        x = Math.random();
        //for (x=0; x<=1; x += 0.05) {
        t = Math.sqrt((Math.log(1/(x*x))));
        result = -( t-(randGaussian_c_0 + randGaussian_c_1*t + randGaussian_c_2*t*t)/(1 + randGaussian_d_1*t + randGaussian_d_2*t*t + randGaussian_d_3*t*t*t) );
        //console.log("x = " + x + ", result = " + result);
        //}
        return result;
    }
    public static randRange(min:number, max:number):number{
        return min + (max-min)*Math.random();
        //return min + (max-min)*0.5;
        //return 0*3.22 + 1*(min + (max-min)*Math.random());
        //return 1.8;
    }
    public static randRangeInt(min:number, max:number):number{
        let max1 = max+1;
        let r =  min + (max1-min)*Math.random();
        let ri = Math.floor(r);
        //console.log(min+"..."+max+":  "+r+"/"+ri)
        return ri;
    }
    public static randRangeIntExcept(min:number, max:number, except:number):number{
        let list:Array<number> = [];
        for (let i:number=min; i<=max; i++){
            if (i != except){
                list.push(i)
            }
        }
        let ri = UtilSP.randRangeInt(0,list.length-1);
        let retval:number = list[ri]
        //console.log(min+"..."+max+", except = "+except+", ri = "+ri+", ret = "+retval,list);
        return retval;
    }    
    public static randRangeWithZeroGap(min:number, max:number):number{
        let a = min + (max-min)*Math.random();
        if (Math.random()>0.5){
            return a;
        } else {
            return -a;
        }
    }
    public static randBool():boolean{
        return ( Math.random() > 0.5 );
    }

    public static clearArray(a:Array<any>){
		// Removes all elements from an array.
		let N:number = a.length;
		if (N>0){
			for (let i=0; i<N; i++){
				a.pop();
			}
		}
	}
	public static fillArrayOfNumbers( A:Array<number>, f:number ):Array<number>{
		// Fills array A with the value f
		let B:Array<number> = new Array();
		if (A.length > 0) {
			for (let i=0; i<A.length; i++){
				B[i] = f;
			}
		} else {
			B = [];
		}
		return B;
    }
	public static fillArrayOfComplex( A:Array<Complex>, f:Complex ):Array<Complex>{
		// Fills array A with the value f
		let B:Array<Complex> = new Array();
		if (A.length > 0) {
			for (let i=0; i<A.length; i++){
				B[i] = f;
			}
		} else {
			B = [];
		}
		return B;
	}    
	public static newFilledArrayOfNumbers( len:number, f:number ):Array<number>{
		// Makes a new array of length len, filled with the value f
		let B:Array<number> = [];
		if (len > 0) {
			for (let i:number=0; i<len; i++){
				B[i] = f;
			}
		} 
		//console.log("In newFilledArrayOfNumbers, len = "+len + ", f = "+f+", B = "+B);
		return B;
    }
	public static shuffledArray(len:number){
		// Returns an array containing integers 0...len in random order (nonrepeating)
		let temp:Array<number> = new Array();
		let i:number, r:number;
		for (i=0; i<len; i++){
			temp.push(i);
		}
		let shuffled:Array<number> = new Array();
		while (temp.length >0 ){
			r = Math.floor( Math.random()*temp.length );
			shuffled.push( temp[r] ); // Copy this element to the shuffled list
			temp.splice(r,1); // Delete it from the ordered list
		}
		return shuffled;
	} 
    public static gaussian(x:number, height:number, center:number, width:number):number{
        // From https://en.wikipedia.org/wiki/Gaussian_function
        let temp = -( (x-center)*(x-center) / ( 2*width*width) );
        let f:number = height * Math.exp( temp );
        return f;
    }
	public static filterGaussian(w:number):Array<number>{
        // Gaussian weighting filter net gain - power transfer function
        // width w should be an odd number
        // 
        let result:Array<number> = new Array();
        let fc:number, i:number, f:number, h:number, w2:number, b:number, cum:number;
        if( w<= 1){
            result[0] = 1;
        }else{
            cum = 0;
            fc = Math.ceil(w/2);
            w2 = Math.floor(w/2);
            b = w2;
            //console.log("w = "+ w + ", fc = " + fc+ ", w2 = " +  w2+ ", b = " +  b );
            for (i=0; i<w; i++){
                f = i - fc + 1;
                h = Math.pow( Math.exp( -(f*f)/(b*b )), 2 );
                //console.log("   "+i+ ", f = " +  f+ ", h = " +  h);
                result[i] = h;
                cum += h;
            }
            // Do not normalize!  Should be 1 at center.
            /*
            //Now force integrated power to equal w:
            for (i=0; i<w; i++){
                result[i] *= w/cum;
            }
            */
        }
        //console.log(result);
        return result;
    }
    public static filterGaussian2(w:number, b:number):Array<number>{
    // Gaussian weighting filter net gain - power transfer function
    // Total width w should be an odd number
    // Bandwidth is b
    // Center is at w/2
        let result:Array<number> = new Array();
        let fc:number, i:number, f:number, h:number, w2:number, cum:number;
        if( w<= 1){
            result[0] = 1;
        }else{
            cum = 0;
            fc = Math.ceil(w/2);
            w2 = Math.floor(w/2);
            //console.log("w = "+ w + ", fc = " + fc+ ", w2 = " +  w2+ ", b = " +  b );
            for (i=0; i<w; i++){
                f = i - fc + 1;
                h = Math.pow( Math.exp( -(f*f)/(b*b )), 2 );
                //console.log("   "+i+ ", f = " +  f+ ", h = " +  h);
                result[i] = h;
                cum += h;
            }
            // Do not normalize!  Should be 1 at center.
        }
        //console.log(result);
        return result;
    }
    public static filterGaussian3(len:number, b:number, fc:number, gain:number):Array<number>{
    // Gaussian weighting filter net gain - power transfer function
    // Total width w should be an odd number
    // Bandwidth is b
    // Center is at w/2
        let result:Array<number> = new Array();
        let i:number, df:number, h:number;
        //, w2:number, cum:number;
        //fc = Math.ceil(w/2);
        //w2 = Math.floor(w/2);
        //console.log("w = "+ w + ", fc = " + fc+ ", w2 = " +  w2+ ", b = " +  b );
        for (i=0; i<len; i++){
            df = i - fc;
            h = Math.pow( Math.exp( -(df*df)/(b*b )), 2 );
            //console.log("   "+i+ ", df = " +  df+ ", h = " +  h);
            result[i] = gain*h;
        }
            // Do not normalize!  Should be 1 at center.
        //console.log(result);
        return result;
    }
    public static modFilterResponseFreqOrder(f:number, Fc:number, Rs:number, alpha:number, filtType:string):number{
        /*Raised cosine or raised root cosine filter for PSK modulation at a given freq f
        i = 0 to N-1
        Fc      Center freq
        Fstep
        N       Number of steps in the sample
        Rs      Symbol rate
        filtType can be "none" "RC" "RRC"

            Filter will have this response:
            = 1 for freq <= filterLowerEdge
            = 0 for freq >= filterUpperEdge
            = "RC" raised cos or "RRC" root raised cos for filterLowerEdge < freq < filterUpperEdge
            Midpoint freq = symbol rate / 2
            alpha is typically 0.2 to 0.35
        */
        let dF:number = Math.abs(f - Fc);
        let dFL = (Rs/2)*(1-alpha);
        let dFU = (Rs/2)*(1+alpha);
        let dFM = 1/Rs; // Mid point
        let resp:number

        if ( dF <= dFL){
            resp = 1;
        } else if ( dF >= dFU){
            resp = 0;
        } else {
            let r = (dF-dFL) / (dFU-dFL) ; // -1/2 to 0 to +1/2
            let theta = (r) *  Math.PI;  // 0 to pi/2 to pi
            
            if (filtType == "RC"){
                resp = (1 + Math.cos(theta))/2;
                //filterCalFactordB = -11.45; // dB
            }else if (filtType == "RRC"){
                resp = Math.sqrt( (1 + Math.cos(theta))/2 );
                //filterCalFactordB = -11.45; // dB
            }else{
                console.log("ERROR in modFilter: invalid filter type "+filtType);
                resp = 0;
            }        
        }
        //console.log("f = "+f+", dF = "+dF+", resp = "+resp);
        return resp;
    }

   
    public static modFilter(f:number, symbrate:number, alph:number, filtType:string):number{
        /*Raised cosine or raised root cosine filter for PSK modulation at a given freq f
        filtType can be "none" "RC" "RRC"
            Filter will have this response:
            = 1 for freq <= filterLowerEdge
            = 0 for freq >= filterUpperEdge
            = "RC" raised cos or "RRC" root raised cos for filterLowerEdge < freq < filterUpperEdge
            Midpoint freq = symbol rate / 2
            alpha is typically 0.2 to 0.35
        */
        let filterMidPoint:number = symbrate/2;
        let filterLowerEdge:number = filterMidPoint* (1 - alph);
        let filterUpperEdge:number = filterMidPoint* (1 + alph);
        let a:number;
        let frq:number;
        if (filtType == "none"){
            a = 1;
            return a;
        }
        frq = Math.abs(f);
        if ( frq <= filterLowerEdge ){
            a = 1;
        }else if ( frq >= filterUpperEdge ){
            a = 0;
        }else{
            let r = (frq-filterMidPoint) / (filterUpperEdge-filterLowerEdge) ; // -1/2 to 0 to +1/2
            let theta = (r+0.5) *  Math.PI;  // 0 to pi/2 to pi
            
            if (filtType == "RC"){
                a = (1 + Math.cos(theta))/2;
                //filterCalFactordB = -11.45; // dB
            }else if (filtType == "RRC"){
                a = Math.sqrt( (1 + Math.cos(theta))/2 );
                //filterCalFactordB = -11.45; // dB
            }else{
                console.log("ERROR in modFilter: invalid filter type "+filtType);
                return 0;
            }
        }
        return a;	
    } 

    public static  bit(d:number, n:number):number{
        // Returns bit n from number d.
        // Rightshift d by n bits, then AND with 0000001
        return ( (d>>n) & 1 );
    } 
    public static  nibble(d:number, n:number):number{
        // Returns nibble n from number d.
        // Rightshift d by n*4 bits, then AND with 00001111
        return ( (d>>n*4) & 15 );
    }      
    public static  byte(d:number, n:number):number{
        // Returns byte n from number d.
        // Rightshift d by n*8 bits, then AND with 11111111
        return ( (d>>n*8) & 255 );
    }     
    public static XOR(a:boolean, b:boolean):boolean{
        return ( a || b ) && !( a && b );
    }
	public static iDirectCNtoPWMVolts(CNR:number, sigLevel:number, sigLevelBaseline:number):number{
		/* Converts CNR and signal level in dB to the PWM voltage dislplayed and output by the iDirect iNFINITY IDU
		Voltage display behavior per Venu Eyyunni (iDirect engineering):
		In lock: 
			V = CNR/2 + 11.    CNR = 2*(V-11).  E.g. V=12, CNR=2.  V-15, CNR = 8.
			11 < V < 22.  
			Typical lock threshold at CNR = 7 for QPSK.  CNR is defined in the signal bandwidth.
			Bar is green.
			Scale is 2 dB per volt.
		Out of lock: 
			V = ( P(rf) - P(cold sky) )/ 2  + 0.3
			2 < V < 8.3
			P is defined as wideband RF power at the IF input to demod.  
			P(cold sky) is the value capture when user clicks OK in the initial dialog.
			Bar is yellow 
			V >= 2.0V
			Scale is 2 dB per volt.
		No signal at all:
			0.3 < V < 2V
			Bar is red
			Return 0.3V
		*/
		let volts:number;
		let CNRlock:number = 7;
		let dS:number = sigLevel- sigLevelBaseline;
		if (CNR >= CNRlock ){
			// Locked.
			volts = 11 + (CNR / 2 );
			volts = Math.min(volts, 22);
		} else {
			volts = 0.3 +  dS/2;
			volts = Math.max(volts, 0.3); // Show min level of 0.3V
			volts = Math.min(volts, 8.3); // Show max level of 8.3V
			if (volts < 2 ){
				volts = 0.3;
			}

		}
		return volts;
	}
	
	public static CNR2iDirectVoltage( CNR:number, CNRlock:number, tunedToCorrectCarrier:boolean, 
        totalWidebandPowerdBm:number, coldSkyWidebandPowerdBm:number ):number{
		let dS:number = totalWidebandPowerdBm - coldSkyWidebandPowerdBm;
		let volts:number;
		if ( (CNR >= CNRlock) && tunedToCorrectCarrier){
			// Locked.
			volts = 11 + (CNR / 2 );
			volts = UtilSP.minmax(volts, 11, 22);
		} else {
			volts = 0.3 +  dS/2;
			volts = UtilSP.minmax(volts, 0.3, 8.3); 
			if (volts < 2 ){
				volts = 0.3;
			}
		}
		return volts;
	}
	
	public static  EsNo2HNSQF( e:number, _EsNoThreshold:number, _tunedToLockableCarrier:boolean, 
        _tunedToCorrectCarrier:boolean, _totalWidebandPowerdBm:number, zeroSQFPowerdBm:number ):number{
		/*
		Curve fits for SQF display when locked to a DVB-S2 signal.
		From document: 
			DVB-S2 ACM SQF Scaling Proposal
			HNS-34654
			Version A.02
			February 28, 2006
		SQF = 31; x < 1.0
		SQF = -0.0044x3 + 0.1799x2 + 1.7624x + 29.179; 1.0 <= x < 7.0
		SQF = 0.0002x5 - 0.0068x4 - 0.0498x3 + 2.6498x2 - 15.154x + 54.645;  7.0<= x <= 12.3
		SQF = 0.0171x3 - 0.8868x2 + 16.367x - 8.9147;  12.3 < x <= 19
		SQF = 99 ; x > 19
		
		Inputs:
			e 	Es/No
			_EsNoThreshold		Typically 1
			_tunedToLockableCarrier  boolean
			_tunedToCorrectCarrier	boolean
			_totalWidebandPowerdBm	-50 dBm gives 29 SWF; 1 SQF unit per dB
			zeroSQFPowerdBm -80 gives similar result as previous version without this parameter.
		E.g.
		
			UtilSP.EsNo2HNSQF(EsNo, 1, true, true, -60)
		*/
		let _SQF:number;
		if ( e < 1 ){
			_SQF = 31;
		} else if ( e >=1 && e < 7.0){
			_SQF = -0.0044*e*e*e + 0.1799*e*e + 1.7624*e + 29.179;
		} else if ( e >= 7.0 && e <= 12.3 ){
			_SQF = 0.0002*e*e*e*e*e - 0.0068*e*e*e*e - 0.0498*e*e*e + 2.6498*e*e - 15.154*e + 54.645;
		} else if ( e > 12.3 && e <= 19 ){
			_SQF = 0.0171*e*e*e - 0.8868*e*e + 16.367*e - 8.9147; 
		} else {
			_SQF = 99;
		}
		
		if ( e > _EsNoThreshold && _tunedToLockableCarrier ){
			if ( ! _tunedToCorrectCarrier ){
				_SQF = 30; // Locked on wrong carrier
			}
		} else {
			
			//_SQF = 29 + _totalWidebandPowerdBm - (-50);  // S+N = -50: SQF = 30.  1 dB per dB.
			_SQF = _totalWidebandPowerdBm - zeroSQFPowerdBm; 
			// Limit to the range 0-29
			_SQF = Math.min(_SQF, 29);
			_SQF = Math.max(_SQF, 0);
		}
		
		return _SQF;
	}
	public static SpaceTrackPointingLossToAGC( signaldBm:number, inputAttendB:number, offSatPct:number ):number{
		/* Converts signal level to AGC value in Schlumberger SpaceTrack tracking receiver
		CNmax = C/N when signaldB = 0 and input att = 0;
		
		AGC = 100:  signal = -25;
		AGC =  0: signal = -85;
		Linear formulas:
		AGC = 100 + (sig+25)*100/60
		Sig = (60/100)*(AGC-100) - 25
		*/
		let PsigW:number = UtilSP.dBW2W( signaldBm - inputAttendB);
		let offSatdB:number = (60/100)*(offSatPct-100) - 25; //(offSatPct-100)/scalePctPerdB;
		let PnoiseWSigma:number = UtilSP.dBW2W( offSatdB );
		let a:number = UtilSP.randGaussian(); // Amplitude
		let PnoiseW:number = PnoiseWSigma * (1 +a*a * 0.1);
		let CNdB:number = UtilSP.W2dBW( PsigW+PnoiseW );
		let AGC:number = UtilSP.minmax(  (100 + (CNdB+25)*100/60 ), 0, 100);  
		//console.log("signaldB = "+signaldBm +", PsigW = "+PsigW+", offSatdB = "+offSatdB +", PnoiseW = "+PnoiseW+", PnoiseWSigma = "+PnoiseWSigma+", CNdB = "+CNdB+", AGC = "+AGC);
		return AGC;		
	}
	public static DIRECTVdB2IRD(dB:number):number{
		/// Curve fit measured dB down from peak to IRD value.
		let curve:number = 0.0314*dB*dB*dB - 0.0034*dB*dB + 1.0699*dB + 97.959;
		let IRD:number = Math.max(0, Math.min(curve, 100) );
		return IRD;
	}
	public static DIRECTV_CN2IRD(CNdB:number):number{
		// Based on measured data on DIRECTV 101 (DSS) with SuperBuddy, 12 May 2009
		if (CNdB > 17){
			return 100;
		}
		if (CNdB < 5){
			return 0; // No lock
		}
		let curve:number =  -0.4916*CNdB*CNdB + 16.257*CNdB - 34.086;
		let IRD:number = Math.max(0, Math.min(curve, 100) );
		//console.log("CNdB = "+CNdB+", curve = "+curve);
		return IRD;
	}
    public static calcWavePoint(t:number, zVal:number, lambda:number, period:number, ampl:number, VAR:number, 
        CPSense:string, propDir:number, polAngle:number, phaseShift:number):THREE.Vector3{ 
        /* Propagates along Z direction.
        propDir = 1  propagates towards +Z.  -1 propagates towards -Z.
        polAngle is positive rotation when looking towards +Z
        CPSense = "RH" when looking towards +Z

        */
        
        let Ai:number = ampl;  // Amplitude of I wave
        let Aq:number = ampl / VAR;  // Amplitude of quadrature wave
        let cpOffset:number;
        //console.log( "phaseShift = "+phaseShift);
        if (CPSense == "RH") {
            cpOffset = 0;
        } else if(CPSense == "LH"){
            cpOffset = 180;
        } else {
            console.log("Error in calcWavePoint: invalid CPSense = "+CPSense+". Choices are RH or LH");
        }

        let p1deg:number  =  -propDir*(zVal/lambda)*360 + (t/period)*360 + phaseShift;

        let x1:number=Aq * Math.cos(UtilSP.radians(p1deg));
        let y1:number=Ai * Math.sin(UtilSP.radians(p1deg + cpOffset));
        // Rotate the point by the pol angle:
        let paRad:number = UtilSP.radians(-polAngle);
        let x1r:number= x1*Math.cos(paRad) + y1*Math.sin(paRad);
        let y1r:number= y1*Math.cos(paRad) - x1*Math.sin(paRad);
        let v:THREE.Vector3 = new THREE.Vector3(x1r, y1r, zVal);
        /*
        console.log("in calcWavePoint: velocity = "+velocity+", dir = "+propDir+", lambda = "+lambda+", period = "+period+
        ", p1 = "+p1+
        ", v = "+UtilSP.vector3toString(v));
        */
        return v;
    }  
	public static isEven(n:number){
		if (n % 2 == 0 ){
			return true;
		} else {
			return false;
		}
	} 
    public static digitalClock(secs:number):string{
        //Returns a string with the time in hh:mm:ss format.  Input in seconds
        let hrs = secs /( 60 * 60 );
        let time = hrs - 24* Math.floor( hrs/24);
        let hours =  Math.floor(time);
        let h:String =  UtilSP.formatIntegerWithZeros( hours, 2);
        let minutes = Math.floor( 60*(time - hours));
        let m:String = UtilSP.formatIntegerWithZeros( minutes, 2);
        let seconds = Math.floor( 60*60*(time - hours - minutes/60));
        let s:String = UtilSP.formatIntegerWithZeros(seconds, 2);
        //console.log(time+" = "+ hours+" : "+  minutes+" : "+ seconds);
        return h+":"+m+":"+s;
    }
    public static digitalClockHMS1(secs:number):string{
        //Returns a string with the time in hh:mm:ss.s format.  Input in seconds
        let hrs = secs /( 60 * 60 );
        let time = hrs - 24* Math.floor( hrs/24);
        let hours =  Math.floor(time);
        let h:string =  UtilSP.formatIntegerWithZeros( hours, 2);
        let minutes = Math.floor( 60*(time - hours));
        let m:string = UtilSP.formatIntegerWithZeros( minutes, 2);
        let seconds = Math.floor( 60*60*(time - hours - minutes/60));
        let s:string = UtilSP.formatIntegerWithZeros(seconds, 2);
        let d:string = (Math.floor(10 * (secs % 1))).toFixed(0);
        //console.log(time+" = "+ hours+" : "+  minutes+" : "+ seconds);
        return h+":"+m+":"+s+"."+d;
    }		
    public static digitalClockHM(secs:number):string{
        //Returns a string with the time in hh:mm format.  Input in seconds
        let hrs = secs /( 60 * 60 );
        let time = hrs - 24* Math.floor( hrs/24);
        let hours =  Math.floor(time);
        let h:string =  UtilSP.formatIntegerWithZeros( hours, 2);
        let minutes = Math.floor( 60*(time - hours));
        let m:string = UtilSP.formatIntegerWithZeros( minutes, 2);
        //console.log(time+" = "+ hours+" : "+  minutes+" : "+ seconds);
        return h+":"+m;
    }
    public static digitalClockHMSn(time_secs:number, nPlaces):string{
        //Returns a string with the time in hh:mm:ss.s format.  Input in seconds
        let hrs_int:number = Math.floor(time_secs /( 60 * 60 ));
        let min_float:number = time_secs/60 - hrs_int*60;
        let min_int:number = Math.floor(min_float);
        let secs_float:number = time_secs - hrs_int*3600 - min_int*60;

        let clock:string = "";
        if (hrs_int > 0){
            clock += UtilSP.formatIntegerWithZeros(hrs_int,2) + ":";
        }
        clock += UtilSP.formatIntegerWithZeros(min_int,2)  + ":";
        if (secs_float < 10){
            clock += "0";
        }
        clock += secs_float.toFixed(nPlaces);

        return clock;
    }    
    public static formatIntegerWithZeros(num:number, digits:number):string {
        //format a number as an integer with leading zeros and a specified number total digits
        //  12, 4 -> 0012
        //  12, 3 ->  012
        //  12, 2 ->   12
        //  12, 1 ->   12
    
        //if no decimal places needed, we're done
        if (digits <= 0) {
                return Math.round(num).toFixed(0); 
        } 
        let n:number = Math.floor(num);
        //round the number to specified decimal places
        //e.g. 12.3456 to 3 digits (12.346) -> mult. by 1000, round, div. by 1000
        let s:string = String(n);		
        if (n < Math.pow(10, digits-1) ){
            s = String(n);
            for (let p=1; p<=digits-1; p++){
                if ( n < Math.pow(10, p)){
                    s = "0"+s;
                }
            }
        }
        return s;
    }
 	public static resampleArrayC(origArray:Array<Complex>, newLength:number):Array<Complex>{
		let N = origArray.length;
		let tempArray:Array<Complex> = new Array(N);
		let newArray:Array<Complex> = new Array(newLength);
		
		// Apply filter as rolling average
		let R = N / newLength;
		let nAvg = Math.ceil(R);

		let isComplex:boolean = true; //(origArray[0] is Complex);
		/*
		console.log("--------------------------------------------");
		if (isComplex){
			console.log("origArray = "+ Complex.toString(origArray));
		} else {
			console.log("origArray = "+origArray);
		}
		console.log("newLength= "+newLength+", R = "+R+", nAvg = "+nAvg);
		*/
		var i:number, iLast:number, iThis:number, nAvgActual:number;
		var sum:number = 0;
		var sumC:Complex = Complex.make(0,0);
		for (i=0; i< N; i++){
			if (isComplex){
				sumC = Complex.make(0,0);
			} else {
				sum = 0;
			}
			iLast = Math.min( i+nAvg-1, N-1);
			nAvgActual = iLast - i +1;
			//console.log("i = "+i+", iLast = "+iLast+", nAvgActual = "+nAvgActual);
			for (iThis=i; iThis<=iLast; iThis++){
				if (isComplex){
					sumC.re += origArray[iThis].re;
					sumC.im += origArray[iThis].im;
					//console.log("  iThis = "+iThis+", sumC = "+Complex.toString(sumC));
				} else {
					///sum += origArray[iThis];
					//console.log("  iThis = "+iThis+", sum = "+sum);
				}
			}
			if (isComplex){
				tempArray[i] = new Complex( sumC.re/nAvgActual, sumC.im/nAvgActual );
				//console.log("  Avg val = "+Complex.toString(tempArray[i]));
			}else {
				///tempArray[i] = sum/nAvgActual;
				//console.log("   Avg val = "+tempArray[i]);
			}
		}
		/*
		if (isComplex){
			console.log("tempArray = "+ Complex.toString(tempArray));
		} else {
			console.log("newArray = "+tempArray);
		}
		*/
		// Take new samples by linearly interpolating tempArray
		var i1:number, i2:number, iInterp:number, k:number, val:number, valC:Complex;
		for (k=0; k<newLength; k++){
			iInterp = (k/newLength) * N;
			i1 = Math.floor(iInterp);
			i2 = i1+1;
			if (isComplex){
				valC = new Complex();
				if (i2 < N ){
					valC.re = tempArray[i1].re + (iInterp-i1)*(tempArray[i2].re - tempArray[i1].re);
					valC.im = tempArray[i1].im + (iInterp-i1)*(tempArray[i2].im - tempArray[i1].im);
				} else {
					valC = tempArray[N-1];
				}
				newArray[k] = valC;
			} else {
                /*
				if (i2 < N ){
					val = tempArray[i1] + (iInterp-i1)*(tempArray[i2] - tempArray[i1]);
				} else {
					val = tempArray[N-1];
				}
				newArray[k] = val;
                */
			}
		}
		/*
		if (isComplex){
			console.log("newArray = "+ Complex.toString(newArray));
		} else {
			console.log("newArray = "+newArray);
		}
		*/
		return newArray;
		
	}
	public static insertionSort(indices:Array<number>, values:Array<number>, ascending:boolean){
		// Sorts array values in place; changes array indices to match.
		
		let N:number = values.length
		let i:number;
		let j:number;
		let value:number;
		let index:number;
		
		for(i = 1; i < N; i++){
			value = values[i];
			index = indices[i];
			j = i-1;
			if (ascending){
				while(j >= 0 && values[j] > value){
					values[j+1] = values[j];
					indices[j+1] = indices[j];
					j--;
				}
			} else {
				while(j >= 0 && values[j] < value){
					values[j+1] = values[j];
					indices[j+1] = indices[j];
					j--;
				}
			}
			values[j+1] = value;
			indices[j+1] = index;
		}
	}
    public static modDisplayOrder(stg: any, obj:any, cmd:string, val?:number){
        switch (cmd){
            case "top":
                stg.setChildIndex(obj,stg.children.length-1); // Moves to top
                break;
            case "bottom":
                stg.setChildIndex(obj,0); // // Moves to bottom of script-added symbols
                break;  
            case "down":
                stg.setChildIndex(obj,stg.getChildIndex(obj)-1); // Move down
                break;  
            case "up":
                stg.setChildIndex(obj,stg.getChildIndex(obj)+1); // Move up
                break;  
            case "index":
                stg.setChildIndex(obj,val); // Set to index val
                break;   
            default:
                console.log("ERROR in UtilSP.modDisplayOrder: invalid cmd "+cmd);
                break;               
        }

    }	
	public static snapTo(a:number, s:number):number{
		var retval:number;
		var ss:number = Math.abs(s);
		if (ss == 0){
			retval = a;
		} else {
			retval = Math.round(a/ss) * (ss);
		}
		return retval;
	}
	public static snapPointTo(p:createjs.Point, s:number):createjs.Point{
		let xx:number = UtilSP.snapTo(p.x, s);
		let yy:number =  UtilSP.snapTo(p.y, s);
		let pSnap:createjs.Point = new createjs.Point(xx, yy);
		//console.log("p = "+p+", s = "+s+", pSnap = "+pSnap);
		return pSnap;
	} 
    public static cartesian2RangeAzEl(p:THREE.Vector3):any{
        /*
        Assumes 
        X-Z plane is horizontal
        +Y it to zenith
        +X is due south
        +Z is due West
        */
        let retObj:{range:number, az_deg:number, el_deg:number} = {range:1, az_deg:0, el_deg:0};
        let r:number = Math.sqrt(p.x*p.x + p.y*p.y + p.z*p.z);
        let d:number = Math.sqrt(p.x*p.x + p.z*p.z);

        let az:number = Math.atan2(-p.z, -p.x);
        let el:number = Math.atan2(p.y, d);

        retObj.range = r;
        retObj.az_deg = UtilSP.degrees(az);
        retObj.el_deg = UtilSP.degrees(el);
        return retObj;
    } 
    public static ytStateNo2String(stateNo:number):string{
        //console.log("in ytStateNo2String  "+ stateNo);
        let str:string = ""
        switch ( stateNo ){
            case -1:
                str += "unstarted";
                break;
            case 0:
                str += "ended";
                break;                
            case 1:
                str += "playing";
                break;
            case 2:
                str += "paused";
                break;                
            case 3:
                str += "buffering";
                break;    
            case 5:
                str += "video cued";
                break;     
            default:
                str += "unknown";
                break;     
        }
        str += " ("+stateNo+")";
        return str;
    } 	
    public static ytStateNo2SimpleString(stateNo:number):string{
        //console.log("Player State Change = "+ evt.data);
        let str:string = ""
        switch ( stateNo ){
            case -1:
                str += "STOPPED";
                break;
            case 0:
                str += "STOPPED AT END";
                break;                
            case 1:
                str += "";
                break;
            case 2:
                str += "PAUSED";
                break;                
            case 3:
                str += "BUFFERING";
                break;    
            case 5:
                str += "CUED";
                break;     
            default:
                str += "unknown video state "+stateNo;
                break;     
        }
        return str;
    }  
    public static TrueFalse(val:boolean):string{
        if (val){
            return "TRUE";
        } else {
            return "FALSE";
        }
    }
    public static PassFail(val:boolean):string{
        if (val){
            return "PASS";
        } else {
            return "FAIL";
        }
    }   
	public static StabAntSettings2Pointing( azSetting:number, clSetting:number, elSetting:number, cantAngle:number ):THREE.Vector3{
		// See RB Notebook #1, p. 140-143; also SeaTel\Spherical trig calculations.xlsx
        // Works for SeaTel, Intellian, and similar antennas with az, cross-axis, and el axes.
		let ELdeg = elSetting;
		let CLdeg = -clSetting; // Empirical fix 9/22/2022 from IntellianTheory1Q
		let AZdeg = azSetting;
		let Cdeg = cantAngle;
		
		let EL:number = UtilSP.radians(ELdeg);
		let CL:number = UtilSP.radians(CLdeg);
		let AZ:number = UtilSP.radians(AZdeg);
		let C:number = UtilSP.radians(Cdeg);
		
		let a:number;
		let b:number;
		let h:number;
		let tol:number = 1E-6;
		let dAbs:number;
		let h_AZ_abs:number;

		//console.log("h_AZ_abs = "+UtilSP.degrees(h_AZ_abs)+", h_AZ = "+UtilSP.degrees(h_AZ)+", h = "+UtilSP.degrees(h) );
		let Cp:number = Math.PI/2 - C;
		let cos_ap:number;
		let ap:number;
		let h_Az:number; 
        let hanum:number; 
        let haden:number; 
        let cos_ha:number;
		let bp:number, bpnum, bpden, cos_bp;
		
		cos_ap = Math.cos(EL)*Math.cos(Cp) + Math.sin(EL)*Math.sin(Cp)*Math.cos(CL);
		ap = Math.acos(cos_ap);
		a = Math.PI/2 - ap;
		if (EL == 0){
			b = CL;
			h_Az = 0;
		} else {
			bpnum = Math.cos(Cp) - Math.cos(EL)*Math.cos(ap);
			bpden = Math.sin(EL)*Math.sin(ap);
			cos_bp = bpnum / bpden;
			if (Math.abs(cos_bp)>1){
				if (Math.abs(cos_bp)>1.000000001){
					console.log("WARNING: In StabAntSettings2Pointing, cos(bp) = "+cos_bp+", a = "+a);
				}
				cos_bp = UtilSP.sign(cos_bp);
			}
			bp = Math.acos( cos_bp ) * UtilSP.sign(EL);
			b = (Math.PI - bp)*UtilSP.sign(CL);
			
			hanum = Math.cos(EL) - Math.cos(ap)*Math.cos(Cp);
			haden = Math.sin(ap)*Math.sin(Cp);
			cos_ha = hanum / haden;
			if (Math.abs(cos_ha)>1){
				if (Math.abs(cos_ha)>1.000000001){
					console.log("WARNING: In StabAntSettings2Pointing, cos(h-Az) = "+cos_ha); // 1.0000000000000004 max observed
				}
				cos_ha = UtilSP.sign(cos_ha);
			}
			h_Az = Math.acos( cos_ha ) * UtilSP.sign(EL)* UtilSP.sign(CL);
		}
		h = h_Az + AZ;
		
		
		let headingDeg = UtilSP.degrees(h);
		let attitudeDeg = UtilSP.degrees(a);
		let bankDeg = -UtilSP.degrees(b); // Changed to negative 8/11/2011 RB
		 
		if (isNaN(headingDeg) || isNaN(attitudeDeg) || isNaN(bankDeg) ){
			console.log("ERROR in UtilSP.StabAntSettings2Pointing: headingDeg = "+headingDeg+", attitudeDeg = "+attitudeDeg+", bankDeg = "+bankDeg);
		}
		if ( attitudeDeg > 90 ){
			//console.log("WARNING: in UtilSP.SeaTelSettings2Pointing: headingDeg = "+headingDeg+", attitudeDeg = "+attitudeDeg+", bankDeg = "+bankDeg);
		}
		let hab:THREE.Vector3 = new THREE.Vector3(headingDeg, attitudeDeg, bankDeg);
		//console.log("In 2HAB:\n   AZ = "+AZdeg+", EL = "+ELdeg+", CL = "+CLdeg+", cant = "+Cdeg+"\n"+
		//	  "   --> h = "+headingDeg+", a = "+attitudeDeg+", b = "+bankDeg+", dAbs = "+UtilSP.degrees(dAbs) );
		return hab;
	}
	
	public static  StabAntPointing2Settings( hab:THREE.Vector3, cantAngle ):THREE.Vector3{
		// See RB Notebook #1, p. 140-143; also SeaTel\Spherical trig calculations.xlsx
		let hDeg = hab.x;
		let aDeg = hab.y;
		let bDeg = -hab.z; // Changed to negative 8/11/2011 RB to reverse sense for CW pol vs quaternion rotation angle.
		
		let C = UtilSP.radians(cantAngle);
		let h = UtilSP.radians(hDeg);  // Desired heading (pointing az)
		let a = UtilSP.radians(aDeg);  // Desired attitude (pointing el - cant)
		let b = UtilSP.radians(bDeg); // Desired bank (pointing pol)
		
		let CL:number
        let CLdeg:number;
		let EL:number;
        let ELdeg:number;
		let AZ:number;
        let AZdeg:number;
		let h_AZ:number;
		
		let ap = Math.PI/2 - a;
		let Cp = Math.PI/2 - C;
		let bp = Math.PI - b;
		let sinCL = Math.asin(  Math.sin(ap) * Math.sin(bp) / Math.sin(Cp) );
		CL = -Math.asin(sinCL ); // Fixed 9/22/2022
		
		let w = Math.asin(  Math.sin(bp) * Math.sin(ap) );
		let h2 = Math.asin(  Math.cos(bp) / Math.cos(w) );
		let EL2 = Math.asin( Math.sin(h2) * Math.sin(ap) );
		if (a < 0 ){
			EL2 = -Math.PI - EL2;
		}
		let EL1 = Math.acos(  Math.cos(Cp) / Math.cos(w) );
		let h1 = Math.asin( Math.sin(EL1) / Math.sin(Cp) );
		let h_AZ_1 = h1+h2;
		h_AZ = h_AZ_1 * UtilSP.sign(CL);
		AZ = h - h_AZ;
		EL = EL1 + EL2;
		
		//console.log("h = "+hDeg+", w = "+UtilSP.degrees(w)+", h2 = "+UtilSP.degrees(h2)+", h1 = "+UtilSP.degrees(h1)+", EL1 = "+UtilSP.degrees(EL1)+", EL2 = "+UtilSP.degrees(EL2)+", h_AZ = "+UtilSP.degrees(h_AZ) );
		//console.log("CL = "+UtilSP.degrees(CL)+", EL = "+UtilSP.degrees(EL)+", AZ = "+UtilSP.degrees(AZ) );
		
		CLdeg = UtilSP.degrees(CL);
		ELdeg = UtilSP.degrees(EL);
		AZdeg = UtilSP.degrees(AZ);
		//console.log("In 2Settings:\n"+
		//	  "   --> h = "+hDeg+", a = "+aDeg+", b = "+bDeg+", dAbs = "+UtilSP.degrees(dAbs)+"\n"+
		//	  "       AZ = "+AZdeg+", EL = "+ELdeg+", CL = "+CLdeg+", cant = "+cantAngle  );
		if (isNaN(AZdeg) || isNaN(ELdeg) || isNaN(CLdeg) ){
			console.log("ERROR in UtilSP.StabAntPointing2Settings: AZdeg = "+AZdeg+", ELdeg = "+ELdeg+", CLdeg = "+CLdeg);
		}
		
		let AzElCl:THREE.Vector3 = new THREE.Vector3(AZdeg, ELdeg, CLdeg);
		return AzElCl;
	}  
    public static rangeToLEO(altitude_km, elevation_deg):number{
        // Assumes LEO with a constant altitude passing directly overhead.
        // Returns range to the LEO as a function of elevation angle.
        let b:number = UtilSP.earthRadiuskm;
        let c:number = UtilSP.earthRadiuskm + altitude_km;
        let C:number = UtilSP.radians(elevation_deg + 90);
        let sinB:number = (b/c)*Math.sin(C);
        let B:number = Math.asin(sinB);
        let A:number = Math.PI - B - C;
        let sinA:number = Math.sin(A);
        let a:number = b * sinA / sinB;
        return a; 
    }

    public static ip4octets2value(octetA:number,octetB:number,octetC:number,octetD:number):number{
        let val = 
            octetA * Math.pow(2,24) +
            octetB * Math.pow(2,16) +
            octetC * Math.pow(2,8) +
            octetD;
        val = val >>> 0;///  >>> 0 forces it to become an unsigned 32 bit integer
        return val;
    }

    public static ip4netmaskbits2maskval(netmaskbits:number):number{
    
        let ns:number = netmaskbits;
        let nsc:number = 32 - ns;
        let mc:number = (Math.pow(2,nsc) - 1);
        mc = mc >>> 0;
        let m:number = ~mc;
        m = m >>> 0;  
        return m; // 32 bit unsigned integer
    }
    public static ip4Details(srcip:number, destip:number, netmaskbits:number):any{
        let retObj:any = {};
        let ns:number = netmaskbits;
        let nsc:number = 32 - ns;
        let s:number = srcip >>> 0;///  >>> 0 forces it to become an unsigned 32 bit integer
        let sUpper = s >>> nsc; // Shift right by number of bits on local addr field
        sUpper = sUpper>>> 0;
        let d:number = destip >>> 0;
        let dUpper = d >>> nsc; // Shift right by number of bits on local addr field
        retObj.isLocal = (sUpper == dUpper);
        
        let localMin = sUpper << nsc;  // Shift left by nsc, bringing zeroes
        localMin = localMin >>> 0;///  >>> 0 forces it to become an unsigned 32 bit integer;
        let localMax = localMin + Math.pow(2,nsc) - 1; // Fill lower nsc bits with 1s
        let localMinObj:any = UtilSP.ip4format(localMin);
        let localMaxObj:any = UtilSP.ip4format(localMax);

        retObj.localMinDec = localMinObj.ipdec;
        retObj.localMaxDec = localMaxObj.ipdec;
        retObj.localMinBitString = localMinObj.ipbitstring;
        retObj.localMaxBitString = localMaxObj.ipbitstring;
        retObj.destDec = UtilSP.ip4format(destip).ipbitstring;


        let netmaskObj:any = UtilSP.ip4format(UtilSP.ip4netmaskbits2maskval(netmaskbits));
        retObj.netMaskBitString = netmaskObj.ipbitstring;
        retObj.netMaskDec = netmaskObj.ipdec;

        // console.log("s = "+s.toString(2));
        // console.log("sUpper = "+sUpper.toString(2));
        // console.log("localMin = "+localMin.toString(2));
        // console.log("localMax = "+localMax.toString(2));

        return retObj;
    }
    public static ip4isLocal(srcip:number, destip:number, netmaskbits:number):boolean{

        let ns:number = netmaskbits;
        let nsc:number = 32 - ns;
        /*
        let mc:number = (Math.pow(2,nsc) - 1);
        mc = mc >>> 0;
        let m:number = ~mc;
        m = m >>> 0;
        */
        let m:number = UtilSP.ip4netmaskbits2maskval(netmaskbits);

        // let maskObj:any = UtilSP.ip4format(m);
        // let srcObj:any = UtilSP.ip4format(srcip);
        // let destObj:any = UtilSP.ip4format(destip);

        let s:number = srcip >>> 0;///  >>> 0 forces it to become an unsigned 32 bit integer
        s = s >>> nsc; // Shift right by number of bits on local addr field
        let d:number = destip >>> 0;
        d = d >>> nsc; // Shift right by number of bits on local addr field

        let local:boolean = (s == d);
        return local;
        /*
        let mask3:number = ((Math.pow(2,8) - 1)<< 24) >>>0 ; 
        let mask2:number = (Math.pow(2,8) - 1) << 16;
        let mask1:number = (Math.pow(2,8) - 1) << 8;
        let mask0:number = (Math.pow(2,8) - 1) << 0;
        let m3 = ((m & mask3)>>>0) >>> 24;
        let m2 = ((m & mask2)>>>0) >>> 16;
        let m1 = ((m & mask1)>>>0) >>> 8;
        let m0 = ((m & mask0)>>>0) >>> 0;
        let m3bs:string = m3.toString(2).padStart(8,'0');
        let m2bs:string = m2.toString(2).padStart(8,'0');
        let m1bs:string = m1.toString(2).padStart(8,'0');
        let m0bs:string = m0.toString(2).padStart(8,'0');

        retObj.mask3bitstring = m3bs;
        retObj.mask2bitstring = m2bs;
        retObj.mask1bitstring = m1bs;
        retObj.mask0bitstring = m0bs;
        retObj.maskbitstring = m3bs + "."+m2bs + "."+m1bs + "."+m0bs;

        retObj.mask3dec = m3;
        retObj.mask2dec = m2;
        retObj.mask1dec = m1;
        retObj.mask0dec = m0;
        retObj.maskdec = m3 + "."+m2 + "."+m1 + "."+m0;

        let s:number = srcip >>> 0;
        let s3 = ((s & mask3)) >>> 24;
        let s2 = ((s & mask3)) >>> 16;
        let s1 = ((s & mask3)) >>> 8;
        let s0 = ((s & mask3)) >>> 0;
        retObj.srcdec = s3 + "."+s2 + "."+s1 + "."+s0;

        console.log("s = "+s);

        return retObj;
        */
    }
    public static ip4format(ip:number):any{
        let retObj:any = {};

        let ipdec = ip >>> 0; /// ...0 forces it to become an unsigned 32 bit integer
        let mask3:number = ((Math.pow(2,8) - 1)<< 24) >>>0 ; 
        let mask2:number = (Math.pow(2,8) - 1) << 16;
        let mask1:number = (Math.pow(2,8) - 1) << 8;
        let mask0:number = (Math.pow(2,8) - 1) << 0;
        let ip3dec = ((ipdec & mask3)>>>0) >>> 24;
        let ip2dec = ((ipdec & mask2)>>>0) >>> 16;
        let ip1dec = ((ipdec & mask1)>>>0) >>> 8;
        let ip0dec = ((ipdec & mask0)>>>0) >>> 0;
        let ip3bs:string = ip3dec.toString(2).padStart(8,'0');
        let ip2bs:string = ip2dec.toString(2).padStart(8,'0');
        let ip1bs:string = ip1dec.toString(2).padStart(8,'0');
        let ip0bs:string = ip0dec.toString(2).padStart(8,'0');

        retObj.ip3bitstring = ip3bs;
        retObj.ip2bitstring = ip2bs;
        retObj.ip1bitstring = ip1bs;
        retObj.ip0bitstring = ip0bs;
        retObj.ipbitstring = ip3bs + "."+ip2bs + "."+ip1bs + "."+ip0bs;

        retObj.ip3dec = ip3dec;
        retObj.ip2dec = ip2dec;
        retObj.ip1dec = ip1dec;
        retObj.ip0dec = ip0dec;
        retObj.ipdec = ip3dec + "."+ip2dec + "."+ip1dec + "."+ip0dec;
        return retObj;
    
    }    
    public static shannon_BWCN2thruput(BW_Hz:number, CN_dB:number):number{
        let CN:number = this.dBW2W(CN_dB);
        let T:number = BW_Hz * this.log2(1 + CN);
        return T;
    } 
    public static shannon_SE2EBN0(SE:number):number{
        // Converts spectral efficiency (ratio) to EbNo in dB at Shannon limit
        let EBN0_ratio:number = (Math.pow(2,SE) - 1) / SE;
        return this.Pratio2dB(EBN0_ratio);
    }          
    // Sun functions:
	public static sunAzEl(param:string, Lon_deg:number, Lat_deg:number, yearNo:number, monthNo:number, dayNo:number, UTC_hrs):number{
		// param must be "az" "el" "RA" "dec"
		let J_days:number = this.YMDT2Jdays(yearNo, monthNo, dayNo, UTC_hrs);
		return this.sunAzElDecimalDays(param, Lon_deg, Lat_deg, J_days);
	}
	public static sunAzElDaysUTC(param:string, Lon_deg:number, Lat_deg:number, days:number, UTC_hrs:number):number{
		// param must be "az" "el" "RA" "dec"
		let J_days:number = days + UTC_hrs/24;
		return this.sunAzElDecimalDays(param, Lon_deg, Lat_deg, J_days);
	}
	public static YMDT2Jdays(yearNo:number, monthNo:number, dayNo:number, UTC_hrs:number):number{
		let d0_days:number = 367*yearNo - Math.floor( (7/4)*(yearNo+ Math.floor((monthNo+9)/12)) ) + Math.floor(275*monthNo/9) + dayNo -730531.5; 
		let J_days:number = d0_days + UTC_hrs/24;  // No of days before J2000 at this UTC 
		return J_days;
	}
	//public static function sunAzEl2(param, Lon_deg, Lat_deg, yearNo, monthNo, dayNo, UTC_hrs){
	public static sunAzElDecimalDays(param:string, Lon_deg:number, Lat_deg:number, J_days:number):number{
		// param must be "az" "el" "RA" "dec"

		/* From http://www.stargazing.net/kepler/sun.html		
		'*********************************************************
		QBASIC program by Keith Burnett (kburnett@geocity.com)
		This program will calculate the position of the Sun using a low precision method found on page C24 of the
	    1996 Astronomical Almanac.
		The method is good to 0.01 degrees in the sky over the period 1950 to 2050.*/		

		//d_days =  367 * yearNo - 7 * (yearNo + (monthNo+9) \ 12) \ 4 + 275 * monthNo \ 9 + dayNo - 730531.5 + UTC_hrs/ 24;
		// Get the no of days before J2000 at midnight UTC for this date: 
		//let d0_days = 367*yearNo - Math.floor( (7/4)*(yearNo+ Math.floor((monthNo+9)/12)) ) + Math.floor(275*monthNo/9) + dayNo -730531.5; 
		//let d_days = d0_days + + UTC_hrs/24;  // No of days before J2000 at this UTC 
		let d_days:number = J_days;
		let d0_days:number = Math.floor(d_days);
		let UTC_hrs:number = 24 * (d_days - d0_days);
		//trace("d0_days = "+d0_days+" UTC_hrs = "+UTC_hrs);
		let L_deg:number = this.mod360( 280.461 + .9856474 * d_days); //mean longitude of the Sun.  Need to convert to 0-2pi
		let g_deg:number = this.mod360( 357.528 + .9856003 * d_days ); //  mean anomaly of the Sun
		let lambda_deg:number = this.mod360(L_deg + 1.915*Math.sin(this.radians(g_deg)) + .02 * Math.sin(this.radians(2*g_deg))); //Ecliptic longitude of the Sun. Ecliptic latitude is assumed to be zero by definition
		let epsilon_deg:number = 23.439  - .0000004 * d_days; // Obliquity of the ecliptic
		let alpha_rad:number = Math.atan2( Math.cos(this.radians(epsilon_deg)) * Math.sin(this.radians(lambda_deg)),  Math.cos(this.radians(lambda_deg)) );// Right ascension:
		let delta_rad:number = Math.asin(  Math.sin(this.radians(epsilon_deg)) * Math.sin(this.radians(lambda_deg)) );// Declination:
		let alpha_deg:number = this.degrees( alpha_rad );
		let delta_deg:number = this.degrees( delta_rad );
		
		// Now we need to convert to local az-el coordinates.
		
		let T0:number = d0_days / 36525; //number of Julian centuries To from J2000.0 
		let S0:number = 6.6974 + 2400.0513*T0; // The sidereal time So (in hours) for the meridian of Greenwich, at midnight (00h) UT 
		let SG:number = S0 + (366.2422 / 365.2422)* UTC_hrs; //The sidereal time SG of the Greenwich meridian, at our time
		let Lon_hrs:number = Lon_deg / 15; 
		let S:number = SG + Lon_hrs; //    local sidereal time S (hours) for the geographical longitude (in hours)
		// The definition of the sidereal time S = Object's Hour Angle  + Right Ascension
		let H:number = S - alpha_deg/15; // Sun's hour angle (hours)
		let H_rad:number = this.radians( H * 15 ); //
		let Lon_rad:number = this.radians(Lon_deg);
		let Lat_rad:number = this.radians(Lat_deg);
		let Y:number = Math.sin(H_rad)*Math.cos(delta_rad);
		let X:number = Math.cos(Lat_rad)*Math.sin(delta_rad) - Math.sin(Lat_rad)*Math.cos(delta_rad)*Math.cos(H_rad);
		let az_deg:number = this.degrees( Math.atan2( -Y, X ) );
		let el_rad:number = Math.asin(Math.sin(Lat_rad)*Math.sin(delta_rad) + Math.cos(Lat_rad)*Math.cos(delta_rad)*Math.cos(H_rad));
		let el_deg:number = this.degrees( el_rad );
		
		/*
		Test case:
		yearNo = 1997;
		monthNo = 8;
		dayNo = 7;
		UTC_hrs = 11.0;

		Results:
		L = 136.00716 deg
		g = 213.11547 deg
		*/
		/*
		trace("Lambda = "+lambda_deg); // = 134.97925
		trace("epsilon = "+epsilon_deg); // = 23.439351
		trace("alpha = "+alpha_deg); // = 137.44352 deg
		trace("delta = "+delta_deg); // = 16.342193
		trace("az = "+az_deg);
		trace("el = "+el_deg);
		*/
		let res:number;
		if ( param == "az" ){
			res = az_deg;
		}else if(param == "el"){
			res = el_deg;
		}else if(param == "RA"){
			res = alpha_deg;
		}else if(param == "dec"){
			res = delta_deg;
		}
		return res;
	}   
    public static waveguideCutoff_GHz(a_mm:number, b_mm:number, m:number, n:number, Er):number{
        //Waveguide cutoff freq in GHz for TEmn or TMmn
        let term1:number = m*Math.PI/ (a_mm*0.001);
        let term2:number = n*Math.PI/ (b_mm*0.001);
        let v:number = 3e8/Er
        let omega = v*Math.sqrt( term1*term1 + term2*term2 );
        let f_GHz = 1e-9 * omega / (2*Math.PI);
        return f_GHz;
    }     
      
}
